<template>
  <div @mousedown="mouseDownMovie">
    <div
      v-bind:class="{ 'd-none': !editRightMouseMovieBlock.show }"
      :style="{
        'z-index': 100,
        position: 'absolute',
        left: editRightMouseMovieBlock.X,
        top: editRightMouseMovieBlock.Y,
      }"
    >
      <!-- :style="'z-index: 100;position:absolute;left: '+editRightMouseMovieBlock.X+ ';top:'+ editRightMouseMovieBlock.Y+';' " -->
      <!-- Console{{editRightMouseMovieBlock}} -->
    </div>
    <div class="white-wrapper mb-4" @click="hideSection">
      <div class="row">
        <div class="col-lg-6 col-xl-4 d-flex">
          <div class="dropdown-curve-container">
            <multiselect
              class="selectCinemaDandD"
              v-model="cinemasSelected"
              :placeholder="cinemaSelectedPlaceHolder"
              :options="Cinemas"
              :disabled="isRoleID"
              @select="onSelectCinemaFromMultiSelect($event)"
              label="cine_name"
              track-by="cine_id"
              :multiple="false"
            ></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-8">
          <div class="row">
            <span
              class="date-arrow date-arrow-left"
              @click="dateHandler('pre')"
            >
              <img
                src="@/assets/img/icons/left-caret.svg"
                height="20"
                width="20"
              />
            </span>
            <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker selectDandDDate">
                  <Datepicker
                    :monday-first="true"
                    typeable
                    ref="programaticOpen"
                    v-model="scheduleObject.sch_start_date"
                    name="uniquename"
                    @selected="doSomethingInParentComponentFunction"
                    :disabled-dates="disabledDates"
                  ></Datepicker>
                  <label :class="scheduleObject.sch_start_date ? 'active' : ''"
                    >Show Date</label
                  >
                </div>
                <span
                  style="
                    display: flex;
                    align-content: center;
                    justify-content: center;
                    align-items: center;
                    padding-inline: 5px;
                  "
                >
                  ({{
                    moment(scheduleObject.sch_start_date || moment()).format(
                      "dddd"
                    )
                  }}, Week
                  {{
                    moment(scheduleObject.sch_start_date || moment()).format(
                      "ww"
                    )
                  }})
                </span>
              </div>
            </div>
            <span
              class="date-arrow date-arrow-right"
              @click="dateHandler('next')"
            >
              <img
                src="@/assets/img/icons/right-caret.svg"
                height="20"
                width="20"
              />
            </span>

            <!-- <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <Datepicker :monday-first="true"
                    ref="programaticOpen"
                    v-model="scheduleObject.sch_end_date"
                    name="uniquename"
                    @selected="doSomethingInParentComponentFunction"
                    :disabledDates="{ to: scheduleObject.sch_start_date}"
                  ></Datepicker>
                  <label
                    :class="scheduleObject.sch_end_date && typeof scheduleObject.sch_end_date === 'object' ? 'active': ''"
                  >End Date</label>
                </div>
              </div>
            </div>-->
            <div
              v-if="isMovieSelected && isChanged"
              class="px-3 d-flex align-items-center"
            >
              <button class="btn-blue mw-auto mr-3" @click="submitSchedule()">
                Save {{ getStatusId == 19 ? "Planned" : "" }} Schedule
              </button>
              <button
                class="btn-blue mw-auto mr-3"
                @click="submitScheduleAndGoBack()"
              >
                Save {{ getStatusId == 19 ? "Planned" : "" }} Schedule &amp; Go
                Back
              </button>
            </div>
          </div>
        </div>

        <div class="col-lg-12 col-xl-12 mt-4">
          <div class="d-flex">
            <div class="align-self-center">
              <button
                :disabled="btenable"
                v-on:click="getSchedule()"
                class="btn-blue mw-auto mr-3"
              >
                Get All Schedule
              </button>
            </div>
            <div class="align-self-center">
              <button
                :disabled="btenable"
                v-on:click="getSchedule(16)"
                class="btn-blue mw-auto mr-3"
              >
                Get Confirmed Schedule
              </button>
            </div>
            <div class="align-self-center">
              <button
                :disabled="btenable"
                v-on:click="getSchedule(19)"
                class="btn-blue mw-auto mr-3"
              >
                Get Planned Schedule
              </button>
            </div>
            <div
              class="color-coding d-flex flex-wrap w-38"
              v-if="typeList.length > 0"
            >
              <div
                class="pr-3 mb-2"
                v-for="(type, typeIndex) in typeList"
                :key="typeIndex"
              >
                <div class="d-flex justify-content-center align-items-center">
                  <div class="">
                    <div
                      class="color-box-2"
                      :style="'background-color:' + type.color"
                    ></div>
                  </div>
                  <div class="color-combination ml-1">
                    {{ type.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- RIGHT SIDE MOVIES LIST -->
    <div v-if="showScheduleCard" class="schedule-wrapper" @click="hideSection">
      <div class="d-flex w-100">
        <div class="left-nav dragMovie">
          <div class="sch-header">Movies</div>
          <div class="px-3 py-2 position-relative">
            <input
              type="search"
              @keyup="onSearch()"
              @keydown="onSearch()"
              v-model="filmTitle"
              class="form-control form-control-sm pr-4"
              aria-label="Search"
              placeholder="Type a film title"
            />
            <button
              @click="getAllActiveMovies()"
              class="position-absolute btn-transparent"
              style="top: 11px; right: 15px"
            >
              <img
                src="@/assets/img/icons/search-global.svg"
                width="17"
                height="17"
              />
            </button>
          </div>
          <b-tabs content-class="pt-2" nav-wrapper-class="nav-underline">
            <b-tab
              @click.prevent.stop="changeTab('Films')"
              title="Films"
              active
            >
              <div
                v-if="MoviesList && MoviesList.length > 0"
                class="oy-auto"
                style="height: calc(100vh - 180px)"
              >
                <drag
                  :class="
                    `px-3 py-1 border-bottom ${
                      !movie.mrrdr_runtime || movie.mrrdr_runtime == 0
                        ? 'ssmv-red-color cursor-no-drop'
                        : ''
                    }`
                  "
                  v-for="(movie, movieIndex) in MoviesList"
                  :key="movieIndex"
                  :draggable="getStatusId !== 19"
                  :transfer-data="{
                    type: 'newMovie',
                    movie: movie,
                    movieIndex: movieIndex,
                    isNoRuntime: !(
                      movie.mrrdr_runtime && movie.mrrdr_runtime != 0
                    ),
                  }"
                  :id="'movie' + (movieIndex + 1)"
                >
                  <div slot="image" class="drag-image">
                    <p
                      class="fs-14 text-truncate mb-0"
                      :title="getMovieVersionText(movie)"
                    >
                      <span class="font-weight-semi-bold">{{
                        movie.movie_title
                      }}</span>
                      ({{ getMovieVersionText(movie) }})
                    </p>
                    <span class="fs-12 text-muted"
                      >Release: {{ movie.mrrdr_release_date | dateparse }} | ({{
                        movie.mrrdr_runtime
                      }})</span
                    >
                  </div>
                  <p
                    class="fs-14 text-truncate mb-0"
                    :title="getMovieVersionText(movie)"
                  >
                    <span class="font-weight-semi-bold">{{
                      movie.movie_title
                    }}</span>
                    ({{ getMovieVersionText(movie) }})
                  </p>
                  <span class="fs-12 text-muted"
                    >Release: {{ movie.mrrdr_release_date | dateparse }} | ({{
                      movie.mrrdr_runtime
                    }}
                    mins)</span
                  >
                </drag>
              </div>
              <div v-else class="text-center py-3">
                <p>No movies found.</p>
              </div>
            </b-tab>

            <b-tab @click.prevent.stop="changeTab('Recent')" title="Recent">
              <div
                v-if="MoviesList && MoviesList.length > 0"
                class="oy-auto"
                style="height: calc(100vh - 180px)"
              >
                <!-- <ul class="list-unstyled bg-white">
                  <li
                    class="px-3 py-2 border-bottom"
                    v-for="(moviesList , moviesListKey2) in MoviesList"
                    :key="moviesListKey2"
                  >
                    <p class="text-truncate mb-0">
                      <span class="fs-14 font-weight-semi-bold">{{moviesList.movie_title}}</span>
                      ({{moviesList.lang_name}})
                    </p>
                    <span
                      class="fs-12 text-muted"
                    >Release: {{ moviesList.mrrdr_release_date | dateparse }} | ({{ moviesList.mrrdr_runtime }} mins)</span>
                  </li>
                </ul>-->
                <drag
                  :class="
                    `px-3 py-1 border-bottom ${
                      !movie.mrrdr_runtime || movie.mrrdr_runtime == 0
                        ? 'ssmv-red-color cursor-no-drop'
                        : ''
                    }`
                  "
                  v-for="(movie, movieIndex) in MoviesList"
                  :key="movieIndex"
                  :draggable="getStatusId !== 19"
                  :transfer-data="{
                    type: 'newMovie',
                    movie: movie,
                    movieIndex: movieIndex,
                    isNoRuntime: !(
                      movie.mrrdr_runtime && movie.mrrdr_runtime != 0
                    ),
                  }"
                >
                  <div slot="image" class="drag-image">
                    <p class="fs-14 text-truncate mb-0">
                      <span class="font-weight-semi-bold">{{
                        movie.movie_title
                      }}</span>
                      ({{ movie.lang_name }})
                    </p>
                    <span class="fs-12 text-muted"
                      >Release: {{ movie.mrrdr_release_date | dateparse }} | ({{
                        movie.mrrdr_runtime
                      }})</span
                    >
                  </div>
                  <p
                    class="fs-14 text-truncate mb-0"
                    :title="getMovieVersionText(movie)"
                  >
                    <span class="font-weight-semi-bold">{{
                      movie.movie_title
                    }}</span>
                    ({{ getMovieVersionText(movie) }})
                  </p>
                  <span class="fs-12 text-muted"
                    >Release: {{ movie.mrrdr_release_date | dateparse }} | ({{
                      movie.mrrdr_runtime
                    }}
                    mins)</span
                  >
                </drag>
              </div>
              <div v-else>
                <p>No recent movies found.</p>
              </div>
            </b-tab>
            <b-tab
              @click.prevent.stop="changeTab('Scheduled')"
              title="Scheduled"
            >
              <div
                v-if="MoviesList && MoviesList.length > 0"
                class="oy-auto"
                style="height: calc(100vh - 180px)"
              >
                <drag
                  :class="
                    `px-3 py-1 border-bottom ${
                      !movie.mrrdr_runtime || movie.mrrdr_runtime == 0
                        ? 'ssmv-red-color cursor-no-drop'
                        : ''
                    }`
                  "
                  v-for="(movie, movieIndex) in MoviesList"
                  :key="movieIndex"
                  :draggable="getStatusId !== 19"
                  :transfer-data="{
                    type: 'newMovie',
                    movie: movie,
                    movieIndex: movieIndex,
                    isNoRuntime: !(
                      movie.mrrdr_runtime && movie.mrrdr_runtime != 0
                    ),
                  }"
                >
                  <div slot="image" class="drag-image">
                    <p class="fs-14 text-truncate mb-0">
                      <span class="font-weight-semi-bold">{{
                        movie.movie_title
                      }}</span>
                      ({{ movie.lang_name }})
                    </p>
                    <span class="fs-12 text-muted"
                      >Release: {{ movie.mrrdr_release_date | dateparse }} | ({{
                        movie.mrrdr_runtime
                      }})</span
                    >
                  </div>
                  <p
                    class="fs-14 text-truncate mb-0"
                    :title="getMovieVersionText(movie)"
                  >
                    <span class="font-weight-semi-bold">{{
                      movie.movie_title
                    }}</span>
                    ({{ getMovieVersionText(movie) }})
                  </p>
                  <span class="fs-12 text-muted"
                    >Release: {{ movie.mrrdr_release_date | dateparse }} | ({{
                      movie.mrrdr_runtime
                    }}
                    mins)</span
                  >
                </drag>
                <!-- <ul class="list-unstyled bg-white">
                  <li
                    class="px-3 py-2 border-bottom"
                    v-for="(moviesList , moviesListKey3) in MoviesList"
                    :key="moviesListKey3"
                  >
                    <p class="text-truncate mb-0">
                      <span class="fs-14 font-weight-semi-bold">{{moviesList.movie_title}}</span>
                      ({{moviesList.lang_name}})
                    </p>
                    <span
                      class="fs-12 text-muted"
                    >Release: {{ moviesList.mrrdr_release_date | dateparse }} | ({{ moviesList.mrrdr_runtime }} mins)</span>
                  </li>
                </ul>-->
              </div>
              <div v-else>
                <p>No scheduled movies found.</p>
              </div>
            </b-tab>
          </b-tabs>
        </div>

        <!-- TIME SCHEDULER     -->
        <div class="right-nav d-flex" @scroll="scrolfun">
          <!-- <div class="schedule-screen-list-wrapper"> -->
          <div v-on:dragenter="dragEnd()" class="schedule-screen-list-wrapper">
            <div
              v-on:dragenter="dragEnd()"
              class="schedule-screen-name"
              :style="
                screen.totalSeatLayout <= 0
                  ? 'background-color:red;color:white'
                  : ''
              "
              v-for="(screen, screenIndex) in ScreenList"
              :key="screenIndex"
            >
              <span v-b-tooltip.hover :title="screen.screen_name">{{
                screen.screen_name
              }}</span>
            </div>
          </div>

          <div class="screen-time-wrapper">
            <div
              class="drag-line"
              v-bind:class="{ 'd-none': String(dropLocation.screen) == '-1' }"
              :style="
                'left :' +
                  dropLocation.positionLeft +
                  'px;top:' +
                  (topValue + 40) +
                  'px'
              "
            >
              <span>{{ dropLocation.time }}</span>
            </div>
            <div
              class="drag-line"
              v-bind:class="{ 'd-none': String(dropLocation.screen) == '-1' }"
              :style="
                'left :' +
                  dropLocation.positionLeftEndTime +
                  'px;top:' +
                  (topValue + 40) +
                  'px'
              "
            >
              <span>{{ dropLocation.time }}</span>
            </div>
            <div
              class="screen-timing-header"
              v-on:dragenter="dragEnd()"
              :style="'top:' + topValue + 'px;'"
            >
              <div
                class="hour-box-header-dd"
                v-for="(timeHeader, timeHeaderIndex) in intervalsArray"
                :key="timeHeaderIndex"
              >
                <strong>{{ timeHeader.split(" ")[1] }}</strong>
                <div class="minutes-bar-dd"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar h-75"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar border-0"></div>
              </div>
            </div>

            <div
              class="schedule-screen-row"
              v-for="(screen, screenIndex) in ScreenList"
              v-bind:class="
                dropLocation.screen == screenIndex ? 'selectedScreen' : ''
              "
              :key="screenIndex"
            >
              <div
                v-if="
                  selectedMoviesInScreens.length > 0 &&
                    selectedMoviesInScreens[screenIndex].hasOwnProperty(
                      'movies'
                    ) &&
                    selectedMoviesInScreens[screenIndex].movies.length
                "
              >
                <drag
                  v-for="(screenMovie,
                  screenMovieIndex) in selectedMoviesInScreens[screenIndex]
                    .movies"
                  :key="'index' + screenIndex + screenMovieIndex"
                  :transfer-data="{
                    type: 'presentMovie',
                    movie: screenMovie,
                    screenMovieIndex,
                    screenIndex,
                  }"
                  @dragstart="startDrag(screenIndex, screenMovieIndex)"
                  v-bind:style="{
                    width: screenMovie.length + 'px',
                    left: screenMovie.start + 'px',
                    'z-index': 10,
                  }"
                  :class="[
                    'movie-horizontal-card',
                    screenMovie.selected == true ? 'selected-movie-card' : '',
                  ]"
                >
                  <div slot="image" class="drag-image" width="150px">
                    <div class="schedule-content">
                      <!-- <strong class="fs-12 d-block">10:00AM - 3:00AM</strong> -->
                      <strong class="fs-18 d-block text-truncate my-3">{{
                        screenMovie.movie || screenMovie.movie_title
                      }}</strong>
                      <div>
                        <small class="d-block">
                          <span>{{ screenMovie.mf_name }}</span>
                          {{ screenMovie.lang_name }}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div
                    @mousedown="mouseDownMovie"
                    v-on-clickaway="away"
                    v-on:click="
                      onSelectMovie($event, screenIndex, screenMovieIndex)
                    "
                    v-if="screenMovie.ss_show_status != 17"
                    :class="[
                      'schedule-card ',
                      'new-schedule-card ',
                      screenMovie.ss_show_status == 19
                        ? ' status-yellow'
                        : !screenMovie.isNewSchedule
                        ? ' status-green'
                        : !screenMovie.isReady
                        ? ' status-red'
                        : ' status-lightgreen',
                      screenMovie.is_sch_disable == 'Y' ? 'status-grey' : '',
                    ]"
                  >
                    <!-- ADD CLASS 'border-left-green, border-left-orange, border-left-blue, border-left-grey, border-left-red' -->
                    <div class="d-flex align-items-center">
                      <div class="w-100">
                        <!-- //TODO - make AM/PM -->
                        <span class="fs-10 d-block font-weight-semi-bold"
                          >{{ screenMovie.start_time }}-{{
                            screenMovie.end_time
                          }}</span
                        >
                        <p
                          class="fs-10 d-block text-truncate-2 my-1"
                          v-b-tooltip.hover
                          :title="screenMovie.movie"
                        >
                          {{ screenMovie.movie || screenMovie.movie_title }}
                        </p>
                        <span class="text-muted fs-10 d-inline-block"
                          >{{ getMovieVersionText(screenMovie) }}
                        </span>
                      </div>
                      <!-- <div class="w-25 text-right">
                        <button class="btn-transparent" @click="onEditMovie(screenMovie,screen)">
                          <img src="@/assets/img/icons/edit.svg" height="18" width="18" />
                        </button>
                      </div> -->
                    </div>
                    <div class="schedule-content d-none">
                      <div>
                        <!-- <strong>{{screenMovie.movie_title}}</strong> -->
                        <small class="d-block">
                          <span>{{ screenMovie.mf_name }}</span>
                          {{ screenMovie.lang_name }}
                        </small>
                      </div>
                    </div>
                    <!-- v-if="compareDateTime(screenMovie.ss_actual_end_date_time)" -->
                    <div class="schedule-navigations d-none">
                      <button
                        class="btn-schedule-edit"
                        @click="onEditMovie(screenMovie, screen)"
                      >
                        Edit
                      </button>
                      <button
                        v-on:click="
                          onDeleteMovieModal(
                            screen,
                            screenMovie,
                            screenIndex,
                            screenMovieIndex
                          )
                        "
                        class="btn-schedule-delete"
                      >
                        <img
                          src="@/assets/img/icons/delete-red.svg"
                          height="25"
                          width="25"
                          alt
                        />
                      </button>
                    </div>
                  </div>

                  <div
                    v-if="screenMovie.ss_show_status == 17"
                    class="schedule-card"
                  >
                    <div class="schedule-content">
                      <div>
                        <strong>{{ screenMovie.movie_title }}</strong>
                        <small class="d-block">
                          <span>{{ screenMovie.mf_name }}</span>
                          {{ screenMovie.lang_name }}
                        </small>
                      </div>
                      <img v-lazy="baseURL + screenMovie.md_thumbnail_url" />
                    </div>
                    <div>
                      <div v-if="screenMovie.scd_reason">
                        Reason : {{ screenMovie.scd_reason }}
                      </div>
                    </div>
                    <div>Deleted By : {{ screenMovie.scd_created_by }}</div>
                  </div>
                </drag>
              </div>
              <div
                class="hour-box-dd"
                v-for="(hourofDay, hourofDayIndex) in intervalsArray"
                :key="hourofDayIndex"
              >
                <drop
                  class="minutes-bar drop"
                  v-for="(minutes, minutesIndex) in 6"
                  :key="'index' + screenIndex + minutesIndex"
                  @drop="handleDrop"
                  @dragenter="
                    (transferData) =>
                      dragEnter(
                        screenIndex,
                        hourofDay.split(' ')[1],
                        minutes,
                        hourofDayIndex,
                        hourofDay,
                        transferData
                      )
                  "
                ></drop>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PRICE CARD FOOTER -->
    <div v-if="isMovieCardSelected" class="schedule-info-sticky">
      <div class="row flex-nowrap align-items-center">
        <div class="col-3 align-self-center">
          <p class="mb-0 text-truncate" :title="movieSelected.movie">
            {{ movieSelected.movie || movieSelected.movie_title }}
          </p>
          <span class="fs-14"
            >Duration: {{ movieSelected.start_time }} -
            {{ movieSelected.end_time }}</span
          >
        </div>
        <div
          v-if="movieSelected.mycinema_booking_type_id !== 3"
          v-for="(screenType, screenTypeIndex) in selectedScreenSeatTypes"
          :key="screenTypeIndex"
          class="col border-left"
        >
          <div
            @click="onSelectScreenType(screenTypeIndex)"
            class="custom-caret position-relative"
          >
            <span class="fs-14 font-weight-semi-bold">{{
              screenType.sst_seat_type
            }}</span>
            <p class="mb-0 lh-1 text-truncate">
              <span
                v-if="
                  selectedScreenIndex != null &&
                    selectedScreenIndex != -1 &&
                    selectedMovieIndex != null &&
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ] &&
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice.length > 0 &&
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice[screenTypeIndex].rate_card_name
                "
                >({{
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ].scheduleShowPrice[screenTypeIndex].rate_card_name
                    ? selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[screenTypeIndex].rate_card_name
                    : selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[screenTypeIndex].rc_name
                    ? selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[screenTypeIndex].rc_name
                    : ""
                }})</span
              >
            </p>
          </div>
          <div
            v-if="screenTypeIndex == selectedScreenTypeIndex"
            class="schedule-price-dropdown"
            tabindex="100"
          >
            <div
              v-if="
                movieSelected &&
                  movieSelected['scheduleShowPrice'] &&
                  movieSelected['scheduleShowPrice'].length > 0
              "
              class="px-2 pt-2 pb-2"
            >
              <input
                required
                autofocus
                type="search"
                placeholder="Search Rate Card Group"
                class="form-control form-control-sm"
                v-on:keyup="
                  onSearchRateCard(screenTypeIndex, $event.target.value)
                "
                v-on:keydown="
                  onSearchRateCard(screenTypeIndex, $event.target.value)
                "
                v-model="
                  movieSelected.scheduleShowPrice[screenTypeIndex]
                    .searchRateCard
                "
              />
            </div>
            <div
              class="p-2 cursor-pointer hover-card-list"
              v-for="(Ratecard, RatecardIndex) in RatecardsList"
              :key="RatecardIndex"
              @click="onSelectRateCard(screenTypeIndex, screenType, Ratecard)"
              :class="
                Ratecard.rc_name ===
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ].scheduleShowPrice[screenTypeIndex].rc_name &&
                  'hover-card-list'
              "
            >
              {{ Ratecard.rc_g_name }}
            </div>
          </div>
        </div>
        <div
          class="col-2 border-left"
          v-if="movieSelected.mycinema_booking_type_id !== 3"
        >
          <b-dropdown
            size="sm"
            variant="transparent text-left"
            class="w-100 custom-caret"
            no-caret
          >
            <template v-slot:button-content>
              <div>
                <span class="fs-12 text-muted">Schedule Type</span>
                <p class="mb-0 lh-1">{{ selectedStatus }}</p>
              </div>
            </template>
            <b-dropdown-item
              v-for="(status, statusIndex) in scheduleStatusArray"
              :key="statusIndex"
              v-on:click="onSelectStatus($event, status)"
              >{{ status.type }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <div
          v-if="
            !movieSelected.isNewSchedule &&
              movieSelected.mycinema_booking_type_id !== 3
          "
          class="col-2 border-left"
        >
          <button
            class="btn btn-white mw-auto mr-3"
            @click="onClickupdateRateCard()"
          >
            Update Price
          </button>
        </div>

        <div
          v-if="movieSelected.mycinema_booking_type_id === 3"
          class="d-flex justify-content-center align-items-center flex-grow-1"
        >
          Private Show
        </div>

        <div
          v-if="movieSelected.mycinema_booking_type_id === 3"
          class="d-flex justify-content-center align-items-center flex-grow-1"
        >
          <button
            class="btn btn-white mw-auto mr-3"
            @click="showAdmitModal(movieSelected)"
          >
            Update Admits
          </button>
        </div>

        <div class="col-1 border-left">
          <button
            v-on:click="
              onDeleteMovieModal(
                selectedScreen,
                movieSelected,
                selectedScreenIndex,
                selectedMovieIndex
              )
            "
            class="btn-schedule-delete"
          >
            <img
              src="@/assets/img/icons/delete-red.svg"
              height="25"
              width="25"
              alt
            />
          </button>
        </div>
        <!-- <div class="col-3 border-left">
          <b-dropdown size="sm" variant="transparent text-left" class="w-100 custom-caret" no-caret>
            <template v-slot:button-content>
              <div>
                <span class="fs-12 text-muted">Session</span>
                <p class="mb-0 lh-1 text-danger">{{ selectedSessionType }}</p>
              </div>
            </template>
            <b-dropdown-item @click="onSelectSession('Closed')">Closed</b-dropdown-item>
            <b-dropdown-item @click="onSelectSession('Open')">Open</b-dropdown-item>
            <b-dropdown-item @click="onSelectSession('Planned')">Planned</b-dropdown-item>
          </b-dropdown>
        </div>-->
      </div>
    </div>

    <!-- UPDATE MOVIE MODAL -->
    <b-modal
      id="updateMovie"
      ref="updateMovie"
      title="Update Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div class>
                  <date-picker
                    :value="movieSelected.selected_time"
                    @change="onEditStartTime($event)"
                    lang="en"
                    type="time"
                    format="hh:mm a"
                    :minute-step="1"
                    class="time_picker"
                    placeholder="Show Time"
                    name="showtime"
                    id="showtime"
                    v-validate="'required'"
                  ></date-picker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.end_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cine_interval_time_in_mins"
                      type="text"
                      name="intervaltime"
                      id="intervaltime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cine_cleaning_time_in_mins"
                      type="text"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cine_setting_ads_time_in_mins"
                      type="text"
                      name="settingadstime"
                      id="settingadstime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <strong>Mins</strong>
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button v-on:click="onUpdate()" class="btn-blue">Update</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- DELETE MOVIE MODAL -->
    <b-modal
      id="deleteMovieModal"
      ref="deleteMovieModal"
      title="Delete Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_start_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-8">
                <strong
                  >{{ CinemasSettings.cine_interval_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-8">
                <strong
                  >{{ CinemasSettings.cine_cleaning_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-12">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="movieSelected.delete_reason"
                    v-validate="{ required: 'required' }"
                    name="delete_reason"
                    id="delete_reason"
                  />
                  <label>Reason For Deletion</label>
                </div>
              </div>
            </div>
            <p class="error_message">
              <span v-if="deleteSubmit && errors.has('delete_reason')">{{
                errors.first("delete_reason")
              }}</span>
            </p>
          </div>
          <div class="col-12 pt-3 text-center">
            <button
              v-on:click="
                onDeleteMovie(
                  selectedScreen,
                  movieSelected,
                  selectedScreenIndex,
                  selectedMovieIndex
                )
              "
              class="btn-blue"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- ADMITS MODAL -->
    <b-modal id="admits" ref="admits" centered hide-footer hide-header>
      <div class="text-center py-4">
        <h5 class="font-weight-bold">Update Admits</h5>

        <div class="d-flex justify-content-center align-items-stretch my-4">
          <button
            class="plus-minus-btn h-50 w-60"
            @click="handleAdmitChange('sub')"
          >
            -
          </button>
          <input
            type="number"
            v-model="currentAdmits"
            :min="0"
            class="flex-grow-1 form-control h-50"
            @change="handleInputChange"
          />
          <button
            class="plus-minus-btn h-50 w-60"
            @click="handleAdmitChange('add')"
          >
            +
          </button>
        </div>
        <div class="text-muted">Total Admits: {{ totalAdmits }}</div>

        <button @click="onSubmitAdmits()" class="btn btn-primary">
          Confirm
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import momentT from "moment-timezone";
  import MasterService from "@/services/MasterService";
  import scheduleService from "@/services/scheduleService";
  import RefundService from "@/services/RefundService";
  import moment, { min } from "moment";
  import CinemasService from "@/services/CinemasService";
  import { BASEURL } from "@/config/index.js";
  import { uniqBy, throttle, debounce } from "lodash";
  import DatePicker from "vue2-datepicker";
  import { directive as onClickaway } from "vue-clickaway";
  import _ from "lodash";

  export default {
    directives: {
      onClickaway: onClickaway,
    },
    components: { DatePicker },
    data() {
      return {
        filmTitle: "",
        tab: "",
        editRightMouseMovieBlock: {
          show: false,
          X: 0,
          Y: 0,
        },
        clickSelectedMovies: [],
        btenable: false,
        deleteFlag: false,
        submitted: true,

        typeList: [
          {
            color: "green",
            name: "Regular Schedule",
          },
          {
            color: "gold",
            name: "Planned Schedule",
          },
          {
            color: "#88F588",
            name: "Rate Card Data Added",
          },
          {
            color: "red",
            name: "Rate Card Data Not Added",
          },
          {
            color: "#ebebeb",
            name: "Disabled Schedule",
          },
        ],

        disabledDates: {
          to: new Date(Date.now() - 8640000),
        },

        timeZone: {
          tz_name: "",
          tz_utc_offset: "",
        },

        duplicate: {
          cine_id: null,
          ss_start_date: "",
          ss_end_date: "",
        },
        deleteSubmit: false,
        searchRateCard: "",
        topValue: 0,
        intervalsArray: [],
        isRoleID: true,
        Cinemas: [],
        baseURL: BASEURL,
        movieSelected: {
          delete_reason: "Please Enter Reason for Deletion",
          lang_name: "Spanish",
          md_id: 12,
          md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
          mf_name: "3D",
          movie_id: 7,
          movie_is_active: "Y",
          movie_title: "Frozen 2",
          mrrdr_runtime: 132,
          interval_time_in_mins: "",
          cleaning_time_in_mins: "",
          ads_time_in_mins: "",
          start_time: "",
        },
        selectedMovieIndex: null,
        selectedScreenIndex: null,
        selectedScreenTypeIndex: null,
        //
        selectedScreen: {},
        cinemasSelected: [],
        cinemaSelectedPlaceHolder: "Select Cinema",
        selectedCinema: "",
        selectedDuplicateCinema: "",
        lists: {
          movies: [],
          cinemas: {
            list: [],
            selectedCinema: {
              cine_name: "",
            },
          },
          screens: [],
        },
        selectedNewDate: "",
        initialSelectedScreen: "Screen 2",
        silderOne: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 7,
        },
        silderTwo: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 5,
        },
        dropLocation: {
          screen: "-1",
          hour: "",
          minute: "",
          positionLeft: "",
          positionLeftEndTime: "",
          time: "",
        },
        dropLocationClone: {},
        draggedObject: {
          screen: "",
          length: "",
          oldStart: "",
          newStart: "",
          movie: "",
        },
        selectedMoviesInScreens: [],
        selectedMoviesInScreensFlag: false,

        // Saif

        showScheduleCard: false,
        selectedScreenSeatTypes: [],
        selectedRateCardObject: {},

        CinemasList: [],
        MoviesList: [],
        ScreenList: [],
        RatecardsList: [],
        RatecardsListCopy: [],
        CinemasSettings: {
          cine_setting_id: null,
          cine_id: null,
          cine_operation_start_time: null,
          cine_operation_end_time: null,
          cine_cleaning_time_in_mins: null,
          cine_setting_ads_time_in_mins: null,
          cine_interval_time_in_mins: null,
          cine_seat_release_time_in_mins: null,
          cine_cutoff_time_in_mins: null,
          cine_setting_is_active: "Y",
        },
        selected: {
          cinema: "",
        },
        scheduleObject: {
          cinema_id: null,
          sch_start_date: null,
          sch_end_date: null,
          sch_is_active: "Y",
        },

        FinalScreenAndMovieScheduleList: [
          {
            screen_id: null,
            screen_name: "",

            // sch_start_date: null,
            // sch_end_date: null,
            // sch_is_active: "Y",
            movies: [
              {
                movie_details_id: null,
                movie_title: null,
                ss_start_show_time: null,
                ss_end_show_time: null,
                ss_start_date: null,
                ss_end_date: null,
                ss_start_date_time: null,
                ss_end_date_time: null,
                ss_actual_end_date: null,
                ss_actual_end_date_time: null,
                ss_actual_start_date: null,
                ss_actual_start_date_time: null,
                ss_is_active: "Y",
                scheduleShowPrice: [
                  {
                    searchRateCard: null,
                    rate_card_id: null,
                    schedule_show_id: null,
                    screen_seat_type_id: null,
                    p_start_date_time: null,
                    p_end_date_time: null,
                    p_is_active: "Y",
                  },
                ],
              },
            ],
          },
        ],
        FinalArray: [],
        selectedStatusId: 16,
        debounce: null,
        // Saif
        //NEW
        isMovieCardSelected: false,
        selectedSessionType: "Closed",
        getStatusId: 16,
        isChanged: false,
        selectedStatus: "",
        scheduleStatusArray: [
          { type: "Schedule", status_id: 16 },
          { type: "Planned", status_id: 19 },
        ],
        currentAdmits: 0,
        remainingAdmits: 0,
        BookingID: null,
        totalAdmits: 0,
        checkAdmitValid: false,
        AdmitError: "",
      };
    },
    computed: {
      isMovieSelected() {
        return (
          this.selectedMoviesInScreens.filter((singleScreen) => {
            return singleScreen.movies.length > 0;
          }).length > 0
        );
      },
      SelectedDate() {
        return this.scheduleObject.sch_start_date;
      },
    },
    watch: {
      SelectedDate: function(val) {
        console.log("val", val);
        this.$store.dispatch("setSchDropDownDates", val);
      },
    },
    mounted: function() {
      // this.startTour("myScheduleDragAndDropTour2");
      document.addEventListener("keyup", this.arrowLeftRight);
      window.addEventListener("search", this.getActiveMoviesonClear);
    },
    destroyed: function() {
      document.removeEventListener("keyup", this.arrowLeftRight);
      document.removeEventListener("search", this.getActiveMoviesonClear);
    },
    beforeMount: function() {
      // this.getAllActiveScreens();
      // this.getAllMovies();
      // this.getAllActiveCinemas();
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      this.cinema_manager_add_edit_disabled = roleid;
      if (true) {
        this.isRoleID = false;
        this.getCinemaList(obj);
      } else {
        this.getCinemaList(obj);
      }
      // this.getCinemaList(obj);

      this.scheduleObject.sch_start_date = new Date(); // this.$store.getters.schDropDownDate;
      this.scheduleObject.sch_end_date = new Date();
    },
    methods: {
      moment,
      MovieLanguageText: function(movie) {
        let main_text_arr = [];
        let x = movie;
        let temp_arr = [];
        if (x.lang_iso_2) {
          temp_arr.push(x.lang_iso_2);
        }

        if (x.sub_lang_1_iso_2) {
          temp_arr.push(x.sub_lang_1_iso_2);
        }

        if (x.sub_lang_2_iso_2) {
          temp_arr.push(x.sub_lang_2_iso_2);
        }

        if (temp_arr.length > 0) {
          main_text_arr.push(temp_arr.join("/"));
        }

        if (main_text_arr.length > 0) {
          return main_text_arr.toUpperCase();
        } else {
          return "";
        }
      },
      showAdmitModal(show) {
        console.log("show", show);
        this.currentAdmits = 0;
        this.BookingID =
          show.hasOwnProperty("privateShowBookingDetails") &&
          show.privateShowBookingDetails.sb_booking_code
            ? show.privateShowBookingDetails.sb_booking_code
            : null;

        this.remainingAdmits = show.screen_total_seats;
        this.totalAdmits = show.admits;
        this.$refs.admits.show();
      },
      handleInputChange($event) {
        let num = $event.target.value;
        if (num < 0) {
          this.AdmitError = "Cannot have negative values";
          this.checkAdmitValid = false;
        } else if (num > this.remainingAdmits) {
          this.AdmitError = "Exceeded Seat Limit in Audi";
          this.checkAdmitValid = false;
        } else {
          this.checkAdmitValid = true;
        }
      },
      onSubmitAdmits: function() {
        if (!this.checkAdmitValid) {
          return this.$toasted.show(this.AdmitError);
        }
        let payload = {
          seats: "All",
          booking_id: this.BookingID,
          isPrivateShow: true,
          current_admits: parseInt(this.currentAdmits),
        };
        scheduleService
          .updateAdmits(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.getSchedule();
              this.$refs.admits.hide();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show("something went wrong");
          });
      },
      handleAdmitChange: function(type) {
        if (type === "add") {
          if (this.currentAdmits + 1 <= this.remainingAdmits)
            this.currentAdmits += 1;
          else this.$toasted.show("Reached Max Seat Limit In Audi");
        } else if (type === "sub") {
          if (this.currentAdmits - 1 >= 0) this.currentAdmits -= 1;
        }
      },
      dateHandler(type) {
        if (this.scheduleObject.sch_start_date) {
          let date = this.scheduleObject.sch_start_date;
          if (type == "next") {
            this.scheduleObject.sch_start_date = new Date(
              moment(date).add(1, "days")
            );
          } else if (type == "pre") {
            this.scheduleObject.sch_start_date = new Date(
              moment(date).subtract(1, "days")
            );
          }

          this.getSchedule(this.getStatusId);
        }
      },
      onSelectStatus(event, status) {
        this.selectedStatus = status.type;
        // this.getStatusId = status.status_id;
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].ss_show_status = status.status_id;
      },
      getMovieVersionText(movie) {
        // let text = "";
        // text =
        //   (movie.mf_name ? movie.mf_name + "-" : "") +
        //   (movie.lang_name ? movie.lang_name + "-" : "") +
        //   (movie.sound_format_name ? movie.sound_format_name : "");

        // if (text.endsWith("-")) {
        //   text = text.substring(0, text.length - 1);
        // }

        // return text;

        let temp_arr = [];

        if (movie.mf_name) temp_arr.push(movie.mf_name);
        if (movie.lang_iso_2) temp_arr.push(movie.lang_iso_2);
        if (movie.sound_format_name) temp_arr.push(movie.sound_format_name);
        if (movie.resolution_short_code)
          temp_arr.push(movie.resolution_short_code);
        if (movie.aspect_ratio_name) temp_arr.push(movie.aspect_ratio_name);
        if (movie.movie_experience) temp_arr.push(movie.movie_experience);
        if (movie.sub_lang_1_iso_2) temp_arr.push(movie.sub_lang_1_iso_2);
        if (movie.sub_lang_2_iso_2) temp_arr.push(movie.sub_lang_2_iso_2);

        if (temp_arr.length > 0) {
          return temp_arr.join("-").toUpperCase();
        } else {
          return "";
        }

        // if (movie.subtitle_language_name_1 && movie.subtitle_language_name_1.iso_3)
        //   temp_arr.push(movie.subtitle_language_name_1.iso_3);
        // if (movie.subtitle_language_name_2 && movie.subtitle_language_name_2.iso_3)
        //   temp_arr.push(movie.subtitle_language_name_2.iso_3);
        // if (movie.format_name) temp_arr.push(movie.format_name);
      },
      onDeleteMovieModalNew() {
        console.log(this.selectedMoviesInScreens[this.selectedScreenIndex]);
        console.log(this.selectedMoviesInScreens);
        console.log("SCREEN INDEX", this.selectedScreenIndex);
        console.log("SCREEN", this.selectedScreen);

        if (
          this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"][
            this.selectedMovieIndex
          ].isNewSchedule
        ) {
          this.selectedMoviesInScreens[this.selectedScreenIndex][
            "movies"
          ].splice(this.selectedMovieIndex, 1);
          this.isMovieCardSelected = false;
        }
      },
      hideSection() {
        this.selectedScreenTypeIndex = null;
      },
      getActiveMoviesonClear: function(event) {
        this.getAllActiveMovies();
      },
      away: function() {
        this.togglePopUp("close");
        this.dropLocation.screen = "-1";
        // if (this.selectedScreenIndex != null && this.selectedMovieIndex != null) {
        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ].selected = false;
        // }
      },
      mouseDownMovie: function() {
        if (event.button == 2) {
          this.editRightMouseMovieBlock.X = event.screenX;
          this.editRightMouseMovieBlock.Y = event.screenY;
          this.togglePopUp("open");
        }
      },
      togglePopUp: function(type) {
        if (type == "close") {
          this.editRightMouseMovieBlock.show = false;
        }
        if (type == "open") {
          this.editRightMouseMovieBlock.show = true;
        }
      },
      dragEnd: function() {
        console.log("dragend");
        let that = this;
        setTimeout(() => {
          this.dropLocation.screen = -1;
        }, 100);
      },
      compareDateTime: function(ss_actual_end_date_time) {
        return moment(moment.unix(ss_actual_end_date_time)).isAfter(moment());
      },

      scrolfun() {
        this.topValue = event.srcElement.scrollTop;
      },
      onSelectScreenType(ScreenTypeIndex) {
        this.selectedScreenTypeIndex = ScreenTypeIndex;
      },
      onDefaultRateCardEmpty(screenIndex, movieIndex, scheduleIndex) {
        if (
          this.selectedMoviesInScreens[screenIndex]["movies"][movieIndex][
            "scheduleShowPrice"
          ][scheduleIndex].rate_card_id == "" &&
          this.selectedMoviesInScreens[screenIndex]["movies"][movieIndex][
            "scheduleShowPrice"
          ][scheduleIndex].rate_card_id == null
        ) {
          this.selectedRateCardObject.rate_card_id = "";
          this.selectedRateCardObject.rate_card_name = "";
          this.selectedRateCardObject.screen_seat_type_id = "";
          this.selectedRateCardObject.SeatTypeIndex = "";
          this.selectedMoviesInScreens[screenIndex]["movies"][movieIndex][
            "scheduleShowPrice"
          ][scheduleIndex] = [
            {
              rate_card_id: null,
              schedule_show_id: null,
              screen_seat_type_id: null,
              p_start_date_time: null,
              p_end_date_time: null,
              p_is_active: "Y",
            },
          ];
        }
      },
      onSelectRateCard(screenTypeIndex, screenType, rate_card) {
        this.isChanged = true;
        let _Obj = {
          ...this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice[this.selectedScreenTypeIndex],
          rate_card_id: rate_card.rc_id,
          searchRateCard: "",
          rate_card_name: rate_card.rc_g_name,
          rate_card_group_id: rate_card.rc_g_id,
          screen_seat_type_id: screenType.sst_id,
          cinema_id: this.scheduleObject.cinema_id,
          screen_id: this.selectedMoviesInScreens[this.selectedScreenIndex]
            .screen_id,
          md_id: this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].movie_details_id,
          schedule_show_id: this.selectedMoviesInScreens[
            this.selectedScreenIndex
          ].movies[this.selectedMovieIndex].show_schedule_id,
        };
        VueMain.set(
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice,
          this.selectedScreenTypeIndex,
          _Obj
        );
        this.$forceUpdate();

        let nullValues = true;
        let checkArray = this.selectedMoviesInScreens[this.selectedScreenIndex]
          .movies[this.selectedMovieIndex].scheduleShowPrice;
        nullValues = checkArray.some(function(e) {
          return e.rate_card_id == null;
        });

        if (!nullValues) {
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].isReady = true;
        } else {
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].isReady = false;
        }
        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ].scheduleShowPrice.map(x => {
        //   if (x.rate_card_id == null) {
        //     this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //       this.selectedMovieIndex
        //     ].isReady = false;
        //   } else {
        //     this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //       this.selectedMovieIndex
        //     ].isReady = true;
        //   }
        // });

        this.selectedRateCardObject.rate_card_id = rate_card.rc_id;
        this.selectedRateCardObject.rate_card_name = rate_card.rate_card_name;
        this.selectedRateCardObject.screen_seat_type_id = screenType.sst_id;
        this.selectedRateCardObject.SeatTypeIndex = screenTypeIndex;
        this.selectedRateCardObject.rate_card_group_id = rate_card.rc_g_id;

        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice.map((x) => {
          x["searchRateCard"] = "";
        });
        this.RatecardsList = this.RatecardsListCopy;
        this.selectedScreenSeatTypes[this.selectedScreenTypeIndex][
          "rate_card"
        ] = rate_card.rc_g_name;
        this.selectedScreenSeatTypes[this.selectedScreenTypeIndex][
          "rate_card_group_id"
        ] = rate_card.rc_g_id;
        this.selectedScreenTypeIndex = null;
      },
      onSelectSession(type) {
        this.selectedSessionType = type;
      },
      getCinemaList: function(cine_id) {
        //  let payload = null
        //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;

              if (data.Records && data.Records.length === 1) {
                this.cinemasSelected = data.Records[0];
                this.onSelectCinemaFromMultiSelect(data.Records[0]);
                // this.getSchedule(16);
              }

              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.selected.cinema = x.cine_name;
                  this.cinemasSelected.push(x);
                  this.scheduleObject.cinema_id = cine_id;
                }
              });
              if (cine_id && cine_id != 0) {
                this.getAllActiveScreens(cine_id);
                this.getCinemaSetting(cine_id);
                this.getRatecardsList(cine_id);
              }
            } else {
              // Show Error Message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {});
      },
      onChangeTime: function(event) {
        this.movieSelected.start_time = event.target.value;
      },
      onUpdate: function() {
        this.getScheduleChecker()
          .then((result) => {
            if (!result.status) {
              this.$toasted.show(result.message);
            } else if (result.status) {
              let start = 0;
              let old_show_time =
                this.movieSelected.ss_actual_start_date_time || null;
              let movie_name_format = `${this.movieSelected.movie_title} ${this.movieSelected.mf_name} (${this.movieSelected.lang_name})`;

              let ss_actual_start_date_time = null;
              let ss_actual_end_date_time = null;
              let ss_actual_start_date = null;
              let ss_actual_end_date = null;
              let ss_end_date = null;
              let ss_end_date_time = null;

              this.movieSelected.start_time = this.onChangeTimePicker(
                this.movieSelected.selected_time
              );
              start = this.newGetScreenPositionCalc(
                this.movieSelected.start_time,
                this.movieSelected.start_time.split(":")[1]
              );
              this.movieSelected.start = start;
              let end_time = moment(this.movieSelected.selected_time)
                .add(parseInt(this.movieSelected.lengthMinutes), "m")
                .toDate();
              this.movieSelected.end_time = moment(end_time).format("HH:mm");

              let date = moment(this.scheduleObject.sch_start_date).format(
                "YYYY-MM-DD"
              );
              let showtime = format24Hours(date, this.movieSelected.start_time);
              let endShowtime = format24Hours(
                date,
                this.movieSelected.end_time
              );
              let ss_start_date_time = +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );

              function format24Hours(date, time) {
                let newVal = date + " " + time;
                let finalVal = moment(newVal).format("HH:mm");
                return finalVal;
              }

              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).isSameOrAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                if (
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  ).isAfter(
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        this.movieSelected.start_time
                    )
                  )
                ) {
                  ss_actual_start_date = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  ss_actual_start_date_time = +new Date(
                    moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  ss_actual_end_date = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  ss_actual_end_date_time = +new Date(
                    moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD") +
                      "T" +
                      endShowtime +
                      this.timeZone.tz_utc_offset
                  );
                  ss_end_date = moment(date)
                    .add(1, "days")
                    .format("YYYY-MM-DD");

                  ss_end_date_time = +new Date(
                    moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD") +
                      "T" +
                      endShowtime +
                      this.timeZone.tz_utc_offset
                  );
                } else {
                  ss_actual_start_date = moment(date).format("YYYY-MM-DD");
                  ss_actual_start_date_time = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  ss_actual_end_date =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  ss_actual_end_date_time =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        );
                  ss_end_date =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  ss_end_date_time =
                    this.movieSelected.start_time.split(" ")[1] == "PM" &&
                    this.movieSelected.end_time.split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            endShowtime +
                            this.timeZone.tz_utc_offset
                        );
                }
              } else {
                ss_actual_start_date = moment(date).format("YYYY-MM-DD");
                ss_actual_start_date_time = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );
                ss_actual_end_date =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_actual_end_date_time =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                ss_end_date =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_end_date_time =
                  this.movieSelected.start_time.split(" ")[1] == "PM" &&
                  this.movieSelected.end_time.split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
              }
              //   if (
              //     this.movieSelected.hasOwnProperty("isNewSchedule") &&
              //     this.movieSelected.isNewSchedule == false
              //   ) {
              //     let payload = {
              //       show_schedule_id: this.movieSelected.scheduleShowPrice[0]
              //         .schedule_show_id,
              //       screen_id: this.movieSelected.scheduleShowPrice[0].screen_id,
              //       interval_time_in_mins:
              //         this.movieSelected.cine_interval_time_in_mins || null,
              //       cleaning_time_in_mins:
              //         this.movieSelected.cine_cleaning_time_in_mins || null,
              //       ads_time_in_mins:
              //         this.movieSelected.cine_setting_ads_time_in_mins || null,
              //       ss_start_show_time: showtime, // this.movieSelected.start_time,
              //       ss_end_show_time: endShowtime, // this.movieSelected.end_time,
              //       ss_start_date_time: ss_start_date_time,
              //       ss_end_date_time: ss_end_date_time,
              //       ss_actual_end_date: ss_actual_end_date,
              //       ss_actual_end_date_time: ss_actual_end_date_time,
              //       ss_actual_start_date: ss_actual_start_date,
              //       ss_actual_start_date_time: ss_actual_start_date_time,
              //       old_show_time: old_show_time,
              //       movie_format_name: movie_name_format
              //     };
              //     scheduleService
              //       .UpdateCinemaScheduleByShow(payload)
              //       .then(result => {
              //         const { data } = result;
              //         if (data.staus) {
              //           this.$toasted.show(data.message);
              //         } else {
              //           this.$toasted.show(data.message);
              //         }
              //       })
              //       .catch(err => {
              //         this.$toasted.show(err);
              //       });
              //   }
              //
            } else {
              this.$toasted.show(data.message);
            }
            this.$refs.updateMovie.hide();
          })
          .catch((err) => {
            this.$refs.updateMovie.hide();

            this.$toasted.show(err);
          });
      },

      convertToHrs: function(value) {
        let hours = Math.floor(value / 60);
        let minutes = Math.floor(value % 60);
        return hours + " hrs " + minutes + " mins";
      },

      duplicateSchedule: function() {
        this.$refs.duplicateModal.show();
      },

      onEditMovie(screenMovie, screen) {
        this.isChanged = true;
        console.log("OKK");
        this.movieSelected = screenMovie;
        this.selectedScreen = screen;
        this.movieSelected["selected_time"] =
          moment().format("YYYY-MM-DD") + " " + screenMovie.start_time;
        this.$refs["updateMovie"].show();
      },
      onDeleteMovieModal: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        console.log("screen", screen);
        console.log("screenMovie", screenMovie);
        console.log("screenIndex", screenIndex);
        console.log("screenMovieIndex", screenMovieIndex);
        if (
          this.movieSelected.hasOwnProperty("isNewSchedule") &&
          this.movieSelected.isNewSchedule == false
        ) {
          this.selectedScreen = screen;
          this.movieSelected = screenMovie;
          this.selectedScreenIndex = screenIndex;
          this.selectedMovieIndex = screenMovieIndex;
          let ss_id = screenMovie.scheduleShowPrice.map((x) => {
            return x.schedule_show_id;
          });
          if (ss_id && ss_id.length > 0) {
            RefundService.GetShowTransaction({ ss_id: ss_id[0] })
              .then((response) => {
                const { data } = response;
                if (data.status) {
                  if (data.Records.length > 0) {
                    this.$toasted.show(
                      data.Records.length +
                        " transaction(s) wfound for this show. Please apply for refund module"
                    );
                  } else if (
                    screenMovie.unpaid_count &&
                    screenMovie.unpaid_count > 0
                  ) {
                    this.$toasted.show(
                      `(${screenMovie.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
                    );
                  } else {
                    this.isMovieCardSelected = false;
                    this.$refs.deleteMovieModal.show();
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                this.$toasted.show("Something went wrong!");
              });
          } else {
            this.$toasted.show("Something went wrong!");
          }
        } else {
          this.selectedScreenIndex = null;
          this.selectedMovieIndex = null;
          this.selectedMoviesInScreens[screenIndex].movies.splice(
            screenMovieIndex,
            1
          );
          this.isMovieCardSelected = false;
        }
      },
      getSchedule: function(status_id = null) {
        this.isMovieCardSelected = false;
        let self = this;
        this.getStatusId = status_id;

        if (status_id) {
          let status_id_temp = status_id || 16;
          let selectedStatus = this.scheduleStatusArray.filter(
            (x) => x.status_id == status_id_temp
          );
          this.selectedStatus = selectedStatus[0].type;
        }

        if (
          this.scheduleObject.cinema_id == null ||
          this.scheduleObject.cinema_id.length == 0
        ) {
          this.$toasted.show("Please Select Cinema");
        } else {
          this.selectedStatusId = status_id;
          let payload = {};
          let loader = "";
          // this.$refs.showDeletedModal.hide();
          // this.$refs.showPlannedModal.hide();
          loader = this.$loading.show();
          this.selectedMoviesInScreens = this.selectedMoviesInScreens.map(
            (x) => {
              x.movies = [];
              return x;
            }
          );

          this.btenable = true;
          payload = {
            ss_show_status: status_id || "all",
            cinema_id: this.scheduleObject.cinema_id,
            start_date: moment(this.scheduleObject.sch_start_date).format(
              "YYYY-MM-DD"
            ),
            end_date: moment(this.scheduleObject.sch_start_date).format(
              "YYYY-MM-DD"
            ),
            groupbyssid: "Y",
          };

          scheduleService
            .GetCinemaSchedule(payload)
            .then((result) => {
              this.btenable = false;
              const { data } = result;
              loader.hide();

              if (data.status) {
                if (data.Records.length > 0) {
                  let newRecords = data.Records;
                  console.log(
                    "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2084 ~ newRecords",
                    newRecords
                  );
                  let _newRecords = uniqBy(newRecords, "screen_id");
                  newRecords.map((y) => {
                    console.log("y :>> ", y);
                    this.selectedMoviesInScreens.map((x) => {
                      if (String(y.screen_id) === String(x.screen_id)) {
                        let lengthMinutes =
                          parseInt(y.mrrdr_runtime) +
                          parseInt(y.ads_time_in_mins) +
                          parseInt(y.cleaning_time_in_mins) +
                          parseInt(y.interval_time_in_mins);
                        let sign = self.timeZone.tz_utc_offset.charAt(0);
                        let offset = self.timeZone.tz_utc_offset.substring(1);
                        let hours = offset.split(":")[0];
                        let minutes = offset.split(":")[1];

                        let timeZoneFlag =
                          momentT.tz.guess() === self.timeZone.tz_name ||
                          ((momentT.tz.guess() == "Asia/Calcutta" ||
                            momentT.tz.guess() == "Asia/Kolkata") &&
                            (self.timeZone.tz_name == "Asia/Kolkata" ||
                              self.timeZone.tz_name == "Asia/Calcutta"));
                        x.movies.push({
                          lengthMinutes,
                          // length: (lengthMinutes * 30) / 10, //original
                          length: (lengthMinutes * 50) / 60,
                          // length:
                          //   this.getScreenPositionCalc(y.ss_end_show_time) -
                          //   this.getScreenPositionCalc(y.ss_start_show_time),

                          start: self.newGetScreenPositionCalc(
                            y.ss_start_show_time,
                            y.ss_start_show_time.split(":")[1]
                          ),

                          selected_time: !timeZoneFlag
                            ? sign == "+"
                              ? moment(y.ss_start_date_time)
                                  .tz(self.timeZone.tz_name)
                                  .add("-" + hours, "hours")
                                  .add("-" + minutes, "minutes")
                                  .format()
                              : moment(y.ss_start_date_time)
                                  .tz(self.timeZone.tz_name)
                                  .add(hours, "hours")
                                  .add(minutes, "minutes")
                                  .format()
                            : moment(y.ss_start_date_time).format(),
                          movie_details_id: y.movie_details_id,
                          lang_name: y.language_name,
                          start_time: y.ss_start_show_time,
                          //  moment(y.ss_start_show_time, [
                          //   "HH:mm"
                          // ]).format("h:mm A"),
                          end_time: y.ss_end_show_time,
                          // moment(y.ss_end_show_time, ["HH:mm"]).format(
                          //   "h:mm A"
                          // ),
                          cine_interval_time_in_mins:
                            y.interval_time_in_mins ||
                            y.cine_interval_time_in_mins,
                          cine_cleaning_time_in_mins:
                            y.cleaning_time_in_mins ||
                            y.cine_cleaning_time_in_mins,
                          cine_setting_ads_time_in_mins:
                            y.ads_time_in_mins ||
                            y.cine_setting_ads_time_in_mins,
                          mf_name: y.movie_format,
                          sound_format_name: y.sound_format_name,
                          movie_title: y.movie_title,
                          movie: y.movie,
                          md_thumbnail_url: y.md_thumbnail_url,
                          is_sch_disable: y.is_sch_disable,
                          ss_start_show_time: y.ss_start_show_time,
                          ss_end_show_time: y.ss_end_show_time,
                          scheduleShowPrice: y.scheduleShowPrice,
                          ss_start_date: y.ss_start_date,
                          ss_end_date: y.ss_end_date,
                          ss_start_date_time: y.ss_start_date_time,
                          ss_end_date_time: y.ss_end_date_time,
                          ss_is_active: y.ss_is_active,
                          ss_show_status: y.ss_show_status,
                          ss_actual_end_date_time: y.ss_actual_end_date_time,
                          ss_actual_start_date_time:
                            y.ss_actual_start_date_time,
                          scd_reason: status_id == 17 ? y.scd_reason : "",
                          scd_created_by: status_id == 17 ? y.username : "",
                          show_schedule_id: y.ss_id,
                          isNewSchedule: false,
                          mycinema_booking_type_id: y.mycinema_booking_type_id,
                          ss_actual_start_date: y.ss_actual_start_date,
                          ss_actual_end_date: y.ss_actual_end_date,
                          privateShowBookingDetails:
                            y.hasOwnProperty("privateShowBookingDetails") &&
                            y.privateShowBookingDetails
                              ? y.privateShowBookingDetails
                              : null,
                          admits: y.admits || 0,
                          unpaid_count: y.unpaid_count,
                        });
                        console.log(
                          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2110 ~ x.movies",
                          x.movies
                        );
                      }
                      return x;
                    });
                  });

                  this.selectedMoviesInScreensFlag = true;
                } else if (data.Records.length == 0) {
                  let date = moment(this.scheduleObject.sch_start_date).format(
                    "DD-MM-YYYY"
                  );
                  this.$toasted.show(
                    "No Shows Found for the Cinema " +
                      this.selected.cinema +
                      " on Date " +
                      date
                  );
                }
              }
            })
            .catch((err) => {});
          function getLength(startTime, ref) {
            let cinema_start = ref.getScreenPositionCalc(
              ref.CinemasSettings.cine_operation_start_time
            );
            // let show_start_time = ref.getScreenPositionCalc(startTime);
            let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
            if (
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  ref.CinemasSettings.cine_operation_end_time
              ).isSameOrBefore(
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    ref.CinemasSettings.cine_operation_start_time
                )
              )
            ) {
              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    ref.CinemasSettings.cine_operation_end_time
                ).isAfter(
                  moment(moment().format("YYYY-MM-DD") + " " + startTime)
                )
              ) {
                show_start_time = 4320 + ref.getScreenPositionCalc(startTime);
              } else {
                show_start_time = ref.getScreenPositionCalc(startTime);
              }
            } else {
              show_start_time = ref.getScreenPositionCalc(startTime);
            }

            let start_delay = ref.getScreenPositionCalc("00:30");
            return show_start_time - cinema_start + start_delay;
          }
        }
      },

      getScheduleChecker: function() {
        //TO DO Check this function
        let currentDate = "";
        let end_time = "";
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          ).isSameOrAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_end_time
            )
          )
        ) {
          if (
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_end_time
            ).isAfter(
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  moment(this.movieSelected.selected_time).format("HH:mm")
              )
            )
          ) {
            this.currentDate =
              moment(this.movieSelected.ss_start_date)
                .add(1, "days")
                .format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm");
            this.currentDate = moment(this.currentDate).valueOf();

            this.end_time = moment(
              moment(this.movieSelected.ss_start_date)
                .add(1, "days")
                .format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
              .add(parseInt(this.movieSelected.lengthMinutes), "m")
              .toDate();

            this.end_time = moment(this.end_time).valueOf();
          } else {
            this.currentDate =
              moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm");

            this.currentDate = moment(this.currentDate).valueOf();

            this.end_time = moment(
              moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
              .add(parseInt(this.movieSelected.lengthMinutes), "m")
              .toDate();

            this.end_time = moment(this.end_time).valueOf();
          }
        } else {
          this.currentDate =
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");

          this.currentDate = moment(this.currentDate).valueOf();
          this.end_time = moment(
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        }

        return new Promise((resolve, reject) => {
          let payload = {
            cinema_id: this.scheduleObject.cinema_id,
            start_date: moment(this.movieSelected.ss_start_date).format(
              "YYYY-MM-DD"
            ),
            end_date: moment(this.movieSelected.ss_end_date).format(
              "YYYY-MM-DD"
            ),
            groupbyssid: "Y",
          };
          scheduleService
            .GetCinemaSchedule(payload)
            .then((result) => {
              const { data } = result;
              if (data && data.status && data.Records.length > 0) {
                let newRecords = data.Records;
                let array = [];

                for (let index = 0; index < newRecords.length; index++) {
                  const element = newRecords[index];
                  if (
                    element.ss_id !=
                    this.movieSelected.scheduleShowPrice[0].schedule_show_id
                  ) {
                    let old_movie_start_date = moment(
                      element.ss_actual_start_date_time
                    )
                      .tz(this.timeZone.tz_name)

                      .format("YYYY-MM-DD HH:mm:ss");
                    let old_movie_end_date = moment(
                      element.ss_actual_end_date_time
                    )
                      .tz(this.timeZone.tz_name)

                      .format("YYYY-MM-DD HH:mm:ss");
                    let new_movie_end_date = moment(this.end_time).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );
                    let new_movie_start_date = moment(this.currentDate).format(
                      "YYYY-MM-DD HH:mm:ss"
                    );

                    let valid = moment(old_movie_end_date).isBetween(
                      new_movie_start_date,
                      new_movie_end_date
                    );
                    let validSame = moment(old_movie_end_date).isSame(
                      new_movie_end_date
                    );
                    let validSame1 = moment(old_movie_start_date).isSame(
                      new_movie_start_date
                    );
                    let valid1 = moment(new_movie_end_date).isBetween(
                      old_movie_start_date,
                      old_movie_end_date
                    );
                    console.log("valid :>> ", valid);
                    console.log("validSame :>> ", validSame);
                    console.log("validSame1 :>> ", validSame1);
                    console.log("valid1 :>> ", valid1);
                    console.log(
                      " this.selectedScreen.screen_id :>> ",
                      this.selectedScreen.screen_id
                    );
                    if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      valid1
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      valid
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      validSame
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else if (
                      element.screen_id == this.selectedScreen.screen_id &&
                      validSame1
                    ) {
                      resolve({
                        status: false,
                        message:
                          "Movie overlapped, Please select different showtime",
                      });
                      break;
                    } else {
                      array.push(element.ss_start_show_time);
                      if (array.length === newRecords.length) {
                        resolve({ status: true });
                        break;
                      } else {
                        resolve({ status: true });
                      }
                    }
                  } else {
                    resolve({ status: true });
                  }
                }
              } else {
                resolve({ status: true });
              }
            })
            .catch((err) => {
              resolve({ status: false, message: "overlaps", error: err });
            });
        });
      },
      convertToHrs: function(value) {
        let hours = Math.floor(value / 60);
        let minutes = Math.floor(value % 60);
        return hours + "hrs " + minutes + " mins";
      },
      openShowDeletedMoviesModal: function() {
        this.$refs.showDeletedModal.show();
      },
      openShowPlannedMoviesModal: function() {
        this.$refs.showPlannedModal.show();
      },
      newGetScreenPositionCalc: function(hours, minutes) {
        hours = parseInt(hours.split(":")[0]);
        let hourCal = 0;
        let selected = 0;
        this.intervalsArray.map((intervalHour, index) => {
          if (
            parseInt(intervalHour.split(" ")[1].split(":")[0]) == hours &&
            selected == 0
          ) {
            hourCal = index;
            selected = 1;
          }
        });
        let totalMinutes = parseInt(hourCal * 60) + parseInt(minutes);
        let leftShift = parseInt(totalMinutes * 50) / 60;
        return leftShift;
      },

      getScreenPositionCalc: function(start_time) {
        let cinema_start_time = this.CinemasSettings.cine_operation_start_time;
        let cinema_ampm = cinema_start_time.split(" ")[1];
        let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
        let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

        let start = 0;
        let cinema_start = 0;
        let hours = 0;
        let minutes = 0;
        let totalMinutes = 0;
        let ampm = start_time.split(" ")[1];
        minutes = parseInt(start_time.split(":")[1]);
        hours = parseInt(start_time.split(":")[0]);

        // NOT BEING USED AS ALWAYS 24 hours
        if (ampm == "PM" && hours === 12) {
          hours = hours;
        } else if (ampm == "PM") {
          hours = hours + 12;
        }
        // if(cinema_hours < hours){
        //   hours =
        // }

        //TO DO Discuss with yogesh on purpose
        // if (ampm == "AM" && hours === 12) {
        //   totalMinutes = minutes;
        //   // cinema_start = parseInt(totalMinutes * 30) / 10; original
        //   cinema_start = parseInt(totalMinutes * 50) / 60;
        //   return cinema_start;
        // } else {
        //   totalMinutes = parseInt(hours * 60) + minutes;
        //   // cinema_start = parseInt(totalMinutes * 30) / 10; original
        //   cinema_start = parseInt(totalMinutes * 50) / 60;
        //   return cinema_start;
        // }

        totalMinutes = parseInt(hours * 60) + minutes;
        // cinema_start = parseInt(totalMinutes * 30) / 10; original
        cinema_start = parseInt(totalMinutes * 50) / 60;

        // Calculate if on the other end, can reuse this function everywhere
        //use intervalsArray
        let hourCal = 0;
        this.intervalsArray.map((intervalHour, index) => {
          // console.log('intervalHour',intervalHour)
          if (parseInt(intervalHour.split(":")[0]) == hours) {
            hourCal = index;
          }
        });
        totalMinutes = parseInt(hourCal * 60) + minutes;
        cinema_start = parseInt(totalMinutes * 50) / 60;

        return cinema_start;
      },
      checkScheduleShowPriceValidation() {
        return new Promise((resolve, reject) => {
          let bool;
          let finalShows = this.selectedMoviesInScreens.filter((x) => {
            return x.movies.length > 0;
          });
          let finalArray = finalShows.filter((singleScreen) => {
            let array1 = singleScreen.movies.filter((singleMovie) => {
              let array = singleMovie.scheduleShowPrice.filter(
                (singleShowPrice) => {
                  return singleShowPrice.rate_card_id == null;
                }
              );
              return array && array.length > 0;
            });
            return array1 && array1.length > 0;
          });
          return resolve({
            status: finalArray && finalArray.length > 0,
            finalNewArray: finalArray,
          });
        });
      },
      successSubmitSchedule: async function() {
        let self = this;
        this.FinalArray = [];
        let dates = getDates(
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")
        );

        this.FinalScreenAndMovieScheduleList = this.selectedMoviesInScreens.filter(
          (x) => {
            return x.movies.length > 0;
          }
        );

        function getDates(startDate, stopDate) {
          var dateArray = [];
          var currentDate = moment(startDate);
          var stopDate = moment(stopDate);
          while (currentDate <= stopDate) {
            dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
            currentDate = moment(currentDate).add(1, "days");
          }
          return dateArray;
        }

        let dateCount = 0;

        console.log(dates, self.FinalScreenAndMovieScheduleList);

        let finalpromises = self.FinalScreenAndMovieScheduleList.map(
          async (item, itemIndex) => {
            let MainObj = {};
            MainObj["screen_id"] = item.screen_id || null;
            MainObj["sch_is_active"] = self.scheduleObject.sch_is_active || "Y";
            MainObj["scheduleshow"] = [];

            let moviePromises = item.movies.map(async (movie, movieIndex) => {
              // if (movie.isNewSchedule && movie.isNewSchedule == true) {
              MainObj["sch_start_date"] =
                moment(self.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) || null;
              MainObj["sch_end_date"] =
                moment(self.scheduleObject.sch_end_date).format("YYYY-MM-DD") ||
                null;

              let promises = dates.map(async (date, dateIndex) => {
                let MovieObj = {};
                MovieObj["isNewSchedule"] = movie.isNewSchedule;
                MovieObj["show_schedule_id"] = movie.show_schedule_id;
                MovieObj["cinema_id"] = self.scheduleObject.cinema_id;
                MovieObj["screen_id"] = item.screen_id;
                MovieObj["movie_details_id"] = movie.movie_details_id;
                // MovieObj["ss_show_status"] = this.getStatusId;
                MovieObj["ss_show_status"] = movie.ss_show_status;
                MovieObj["interval_time_in_mins"] =
                  movie.cine_interval_time_in_mins;
                MovieObj["cleaning_time_in_mins"] =
                  movie.cine_cleaning_time_in_mins;
                MovieObj["ads_time_in_mins"] =
                  movie.cine_setting_ads_time_in_mins;
                MovieObj["ss_start_show_time"] = movie.start_time;
                MovieObj["ss_end_show_time"] = movie.end_time;
                MovieObj["ss_start_date"] = moment(date).format("YYYY-MM-DD"); // movie.ss_start_date;

                MovieObj["ss_start_date_time"] = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    movie.start_time +
                    self.timeZone.tz_utc_offset
                );
                MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time;
                //actual date
                if (
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      self.CinemasSettings.cine_operation_start_time
                  ).isSameOrAfter(
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        self.CinemasSettings.cine_operation_end_time
                    )
                  )
                ) {
                  if (
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        self.CinemasSettings.cine_operation_end_time
                    ).isAfter(
                      moment(
                        moment().format("YYYY-MM-DD") + " " + movie.start_time
                      )
                    )
                  ) {
                    MovieObj["ss_actual_start_date"] = moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD");
                    MovieObj["ss_actual_start_date_time"] = +new Date(
                      moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD") +
                        "T" +
                        movie.start_time +
                        self.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_actual_end_date"] = moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD");
                    MovieObj["ss_actual_end_date_time"] = +new Date(
                      moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD") +
                        "T" +
                        movie.end_time +
                        self.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_end_date"] = moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD");

                    MovieObj["ss_end_date_time"] = +new Date(
                      moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD") +
                        "T" +
                        movie.end_time +
                        self.timeZone.tz_utc_offset
                    );
                  } else {
                    MovieObj["ss_actual_start_date"] = moment(date).format(
                      "YYYY-MM-DD"
                    );
                    MovieObj["ss_actual_start_date_time"] = +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        movie.start_time +
                        self.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_actual_end_date"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD")
                        : moment(date).format("YYYY-MM-DD");
                    MovieObj["ss_actual_end_date_time"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? +new Date(
                            moment(date)
                              .add(1, "days")
                              .format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          )
                        : +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          );
                    MovieObj["ss_end_date"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD")
                        : moment(date).format("YYYY-MM-DD");

                    MovieObj["ss_end_date_time"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? +new Date(
                            moment(date)
                              .add(1, "days")
                              .format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          )
                        : +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          );
                  }
                } else {
                  MovieObj["ss_actual_end_date"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");
                  MovieObj["ss_actual_start_date"] = moment(date).format(
                    "YYYY-MM-DD"
                  );
                  MovieObj["ss_actual_end_date_time"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        );
                  MovieObj["ss_actual_start_date_time"] = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      movie.start_time +
                      self.timeZone.tz_utc_offset
                  );
                  MovieObj["ss_end_date"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? moment(date)
                          .add(1, "days")
                          .format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  MovieObj["ss_end_date_time"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date)
                            .add(1, "days")
                            .format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        );
                }

                MovieObj["ss_start_date_time"] = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    movie.start_time +
                    self.timeZone.tz_utc_offset
                );
                MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time
                MovieObj["scheduleshowprice"] = [];
                let scheduleShowPricePromises = movie.scheduleShowPrice.map(
                  (price, priceIndex) => {
                    let PriceObj = {};

                    dateCount = PriceObj[
                      "cinema_id"
                    ] = this.scheduleObject.cinema_id;
                    PriceObj["screen_id"] = item.screen_id;
                    PriceObj["md_id"] = movie.movie_details_id;
                    PriceObj["rate_card_id"] = price.rate_card_id;
                    PriceObj["rate_card_group_id"] = price.rate_card_group_id;
                    PriceObj["screen_seat_type_id"] = price.screen_seat_type_id;
                    PriceObj["p_start_date_time"] = date; // price.p_start_date_time;
                    PriceObj["p_end_date_time"] = date; // price.p_end_date_time;
                    PriceObj["p_is_active"] = price.p_is_active || "Y";

                    // Push Show Price
                    MovieObj["scheduleshowprice"].push(PriceObj);
                  }
                );
                await Promise.all(scheduleShowPricePromises);

                // Push Show and Show Price
                MainObj["scheduleshow"].push(MovieObj);
              });
              await Promise.all(promises);
              // }
            });
            await Promise.all(moviePromises);
            // Final Array Push
            this.FinalArray.push(MainObj);
          }
        );

        function format24Hours(date, time) {
          let newVal = date + " " + time;
          let finalVal = moment(newVal).format("HH:mm");
          return finalVal;
        }

        this.btenable = true;
        await Promise.all(finalpromises)
          .then((result) => {
            let loader = this.$loading.show();
            // console.log(this.FinalArray, "fsdfdsfsdfsd");
            // return;
            return scheduleService
              .AddMultiScheduleDD({ AllSchedules: this.FinalArray })
              .then((resp) => {
                this.btenable = false;
                this.isChanged = false;
                loader.hide();
                const { data } = resp;
                if (data && data.status) {
                  this.$toasted.show(data.message);
                } else {
                  if (data.error && data.error.message) {
                    this.$toasted.show(data.error.message);
                  } else {
                    this.$toasted.show(data.message);
                  }
                }
              })
              .catch((err) => {
                this.$toasted.show(err);
              });

            // this.FinalArray.map((x) => {
            //   scheduleService
            //     .AddSchedule(x)
            //     .then((resp) => {
            //       this.btenable = false;
            //       loader.hide();
            //       const { data } = resp;
            //       if (data && data.status) {
            //         this.$toasted.show(data.message);
            //       } else {
            //         if (data.error && data.error.message) {
            //           this.$toasted.show(data.error.message);
            //         } else {
            //           this.$toasted.show(data.message);
            //         }
            //       }
            //     })
            //     .catch((err) => {
            //       this.$toasted.show(err);
            //     });
            // });
          })
          .catch((err) => {
            loader.hide();
            this.$toasted.show(err);
          })
          .finally(() => {
            this.getSchedule(this.getStatusId);
            this.$forceUpdate();
          });
      },
      submitSchedule: async function() {
        if (
          !this.scheduleObject.sch_start_date &&
          !this.scheduleObject.sch_end_date
        ) {
          this.$toasted.show("Please Select Start & End Date");
          return;
        }
        this.checkScheduleShowPriceValidation().then((result) => {
          let arrayNew = [];
          if (result && result.status) {
            console.log(result.finalNewArray);
            let error = result.finalNewArray[0];

            result.finalNewArray[0].movies.map((newMovies) => {
              let filterNew = newMovies.scheduleShowPrice.filter((x) => {
                return x.rate_card_id == null || x.rate_card_id == "";
              });
              if (filterNew.length > 0) {
                arrayNew.push(newMovies);
              }
            });
            this.$toasted.show(
              `Please attach Rate Card for screen ${error.screen_name}  and movie ${arrayNew[0].movie_title} for show ${arrayNew[0].start_time}`
            );
          } else {
            this.successSubmitSchedule();
          }
        });
      },
      submitScheduleAndGoBack() {
        this.submitSchedule();
        this.$router.go(-1);
      },
      getDateTime(date, time) {
        return moment(new Date(date)).format("DD-MM-YYYY");
      },
      // Cinema List
      getAllActiveCinemas: function() {
        scheduleService
          .GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasList = data.Records;
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
          });
      },

      getCinemaSetting: function(cinema_id) {
        //TODO Relook at cinema settings function here
        scheduleService
          .GetCinemaSetting({ cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.CinemasSettings = {
                ...this.CinemasSettings,
                ...data.Records[0],
              };
              this.timeZone = {
                ...this.timeZone,
                ...data.timeZone,
              };

              let startString = "";
              if (
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                  "PM"
              ) {
                startString = moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD h:mm A");
              } else {
                startString = moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).format("YYYY-MM-DD H:mm");
              }

              let endString = "";
              if (
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "AM" ||
                this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                  "PM"
              ) {
                endString = moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD h:mm A");
              } else if (
                moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_start_time
                ).isSameOrAfter(
                  moment(
                    moment(this.scheduleObject.sch_start_date).format(
                      "YYYY-MM-DD"
                    ) +
                      " " +
                      this.CinemasSettings.cine_operation_end_time
                  )
                )
              ) {
                endString = moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else if (
                this.CinemasSettings.cine_operation_end_time.split(":")[0] < 12
              ) {
                endString = moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
                  .add(1, "d")
                  .format("YYYY-MM-DD H:mm");
              } else {
                endString = moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).format("YYYY-MM-DD H:mm");
              }

              // let endString = moment(
              //   moment().format("YYYY-MM-DD") +
              //     " " +
              //     this.CinemasSettings.cine_operation_end_time
              // ).format("YYYY-MM-DD h:mm A");
              this.intervalsArray = intervals(startString, endString);

              function intervals(startString, endString) {
                var start = moment(startString, "YYYY-MM-DD hh:mm a");
                var end = moment(endString, "YYYY-MM-DD hh:mm a");

                // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
                // note that 59 will round up to 60, and moment.js handles that correctly
                start.minutes(Math.ceil(start.minutes() / 15) * 15);

                var result = [];

                var current = moment(start);
                end = moment(end);
                end.add(4 * 60, "minutes");
                while (current <= end) {
                  // let time = current.format("HH:mm");
                  // if (time == "24:00"){

                  // }
                  result.push(current.format("YYYY-MM-DD HH:mm"));
                  current.add(60, "minutes");
                }

                return result;
              }
              this.changeTab("Films");
              this.getAllActiveMovies();
            } else {
              // Show Message Here:
            }
          })
          .catch((error) => {
            // Catch Error:
          });
      },
      onSearchRateCard: function(RatecardIndex) {
        if (
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice[RatecardIndex]["searchRateCard"].length > 0
        ) {
          this.RatecardsList = this.RatecardsListCopy.filter((x) => {
            if (
              x.rc_g_name
                .toLowerCase()
                .includes(
                  this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
                    this.selectedMovieIndex
                  ].scheduleShowPrice[RatecardIndex][
                    "searchRateCard"
                  ].toLowerCase()
                )
            )
              return x;
          });
        } else {
          this.RatecardsList = this.RatecardsListCopy;
        }
      },
      //
      getRatecardsList: function(cinema_id) {
        scheduleService
          .GetRatecardGroupByCinemaId({ cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RatecardsList = data.Records;
              this.RatecardsListCopy = data.Records;
              // this.getSchedule();
            } else {
              // Show Message Here:
            }
          })
          .catch((error) => {
            // Catch Error:
          });
      },
      changeTab: function(name) {
        this.tab = name;
        this.getAllActiveMovies();
      },
      onSearch() {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.getAllActiveMovies();
        }, 1500);
      },
      getAllActiveMovies: function() {
        let loader = this.$loading.show();
        let cinema_id = this.scheduleObject.cinema_id;
        scheduleService
          .GetMoviesDD({ title: this.filmTitle, tab: this.tab, cinema_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult.map(
                (movie, movieIndex) => {
                  movie.lengthMinutes =
                    movie.mrrdr_runtime +
                    parseInt(this.CinemasSettings.cine_cleaning_time_in_mins) +
                    parseInt(
                      this.CinemasSettings.cine_setting_ads_time_in_mins
                    ) +
                    parseInt(this.CinemasSettings.cine_interval_time_in_mins);
                  movie.length = (movie.lengthMinutes * 50) / 60;
                  movie.selected = false;
                  movie.cine_cleaning_time_in_mins = parseInt(
                    this.CinemasSettings.cine_cleaning_time_in_mins
                  );
                  movie.cine_setting_ads_time_in_mins = parseInt(
                    this.CinemasSettings.cine_setting_ads_time_in_mins
                  );
                  movie.cine_interval_time_in_mins = parseInt(
                    this.CinemasSettings.cine_interval_time_in_mins
                  );

                  movie.rateCard = [];
                  movie.scheduleShowPrice = [];
                  return movie;
                }
              );
              console.log(
                "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2947 ~ this.MoviesList=data.MovieListResult.map ~ this.CinemasSettings",
                this.CinemasSettings
              );
              console.log(
                "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2953 ~ this.MoviesList=data.MovieListResult.map ~  this.MoviesList",
                this.MoviesList
              );
              this.showScheduleCard = true;
              // this.lists.movies = movieList;
            } else {
              this.MoviesList = [];
              // Show Message Here:
              // console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },

      getAllActiveScreens: function(cinema_id) {
        // scheduleService.GetScreens()
        //   .then(response => {
        //     const { data } = response;
        //     if (data && data.status && data.Records.length > 0) {
        //       // this.lists.screens = data.Records;
        //       this.ScreenList = data.Records.filter(
        //         x => x.screen_seat_types.length > 0
        //       );
        //       this.ScreenList.map(x => {
        //         this.selectedMoviesInScreens.push({
        //           ...x,
        //           movies: []
        //         });
        //       });
        //     } else {
        //       // Show Message Here:
        //       console.log("data.message :", data.message);
        //     }
        //   })
        //   .catch(error => {
        //     // Catch Error:
        //     this.$toasted.show(Error(error));
        //     console.log("Catch Error on getAllActiveScreens :", error);
        //   });
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };
        this.selectedMoviesInScreens = [];

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              // this.lists.screens = data.Records;
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              let arrayNew = [];
              let haveNotScreen = [];
              let haveSeatArrayScreen = [];
              this.ScreenList.map((x) => {
                if (x.totalSeatLayout > 0) {
                  haveSeatArrayScreen.push(x);
                  this.selectedMoviesInScreens.push({
                    ...x,
                    movies: [],
                  });
                } else {
                  haveNotScreen.push(x);
                  arrayNew.push({
                    ...x,
                    movies: [],
                  });
                }
              });
              this.ScreenList = [...haveSeatArrayScreen, ...haveNotScreen];

              this.selectedMoviesInScreens = [
                ...this.selectedMoviesInScreens,
                ...arrayNew,
              ];

              console.log(this.selectedMoviesInScreens);
              this.getSchedule(this.getStatusId);
            } else {
              // Show Message Here:
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
          });
      },
      getSeatTypesListByScreenId: function(screen_id) {
        scheduleService
          .GetSeatTypesByScreenId({ screen_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
            } else {
              // Show Message Here:
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
          });
      },
      onEditStartTime: function(event) {
        this.movieSelected["selected_time"] = event;
        this.$forceUpdate();
      },
      onChangeTimePicker: function(date) {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes;
        return strTime;
      },
      onOpenAddPriceModal: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        this.movieSelected = screenMovie;
        this.selectedScreenSeatTypes = screen.screen_seat_types;
        this.selectedMovieIndex = screenMovieIndex;
        this.selectedScreenIndex = screenIndex;
        this.$refs.ratecardmodal.show();
      },
      onDeleteMovie: function(
        screen,
        screenMovie,
        screenIndex,
        screenMovieIndex
      ) {
        let movie_name_format = `${screenMovie.movie_title} ${screenMovie.mf_name} (${screenMovie.lang_name})`;
        this.isChanged = true;
        this.deleteSubmit = true;
        this.$validator
          .validate()
          .then((valid) => {
            if (valid) {
              this.$refs.deleteMovieModal.hide();

              this.selectedMoviesInScreens[screenIndex].movies.splice(
                screenMovieIndex,
                1
              );
              let ss_id = screenMovie.scheduleShowPrice.map((x) => {
                return x.schedule_show_id;
              });
              if (ss_id && ss_id.length > 0) {
                let payload = {
                  ss_id: ss_id[0],
                  delete_reason: this.movieSelected.delete_reason,
                  movie_name_format: movie_name_format,
                  ss_actual_start_date_time:
                    screenMovie.ss_actual_start_date_time,
                  ss_start_date: screenMovie.ss_start_date,
                };
                scheduleService
                  .UpdateShowStatus(payload)
                  .then((response) => {
                    const { data } = response;
                    if (data && data.status) {
                      this.$toasted.show(data.message);
                    } else {
                      this.$toasted.show(data.message);
                    }
                  })
                  .catch((err) => {
                    this.$toasted.show(err);
                  });
              }
            }
          })
          .catch(this._CatchError);
      },
      onClickupdateRateCard: function() {
        if (
          (this.selectedRateCardObject &&
            Object.keys(this.selectedRateCardObject).length == 0) ||
          String(this.selectedRateCardObject.SeatTypeIndex).length == 0
        ) {
          this.$toasted.show("Please Select Rate Card Group");
          return;
        }
        console.log(
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ]
        );

        let payload = {
          show_schedule_id: this.selectedMoviesInScreens[
            this.selectedScreenIndex
          ].movies[this.selectedMovieIndex].show_schedule_id,
          scheduleshowprice: this.selectedMoviesInScreens[
            this.selectedScreenIndex
          ].movies[this.selectedMovieIndex].scheduleShowPrice,
        };
        console.log("payload :>> ", payload);
        scheduleService
          .UpdateCinemaScheduleByPrice(payload)
          .then((result) => {
            const { data } = result;
            if (data.status) {
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            this.$toasted.show(this._CatchError);
          });
        this.searchRateCard = "";
      },

      onSelectCinemaFromMultiSelect: function(event) {
        this.selected.cinema = event.cine_name;
        this.selectedDuplicateCinema = event.cine_name;

        this.scheduleObject.cinema_id = event.cine_id;
        this.getAllActiveScreens(event.cine_id);
        this.getCinemaSetting(event.cine_id);
        this.getRatecardsList(event.cine_id);
        this.isMovieCardSelected = false;
      },
      onSelectCinema: function(event, cinema) {
        this.selected.cinema = cinema.cine_name;
        this.selectedDuplicateCinema = cinema.cine_name;

        this.scheduleObject.cinema_id = cinema.cine_id;
        this.getAllActiveScreens(cinema.cine_id);
        this.getCinemaSetting(cinema.cine_id);
        this.getRatecardsList(cinema.cine_id);
      },

      //

      selectCinema: function(cinema) {
        this.lists.cinemas.selectedCinema = cinema;
      },
      doSomethingInParentComponentFunction: function() {
        debounce(() => {
          if (this.scheduleObject.cinema_id) {
            this.getAllActiveScreens(this.scheduleObject.cinema_id);
            this.getCinemaSetting(this.scheduleObject.cinema_id);
            this.getRatecardsList(this.scheduleObject.cinema_id);
          }
          // this.startTour("myScheduleDragAndDropTour3");
        }, 1000);
      },
      changeCinema: function(params) {
        this.initialSelectedScreen = params;
      },
      startDrag: function(screen, movie) {
        console.log(screen, ":fdsfds");
        // console.log(this.selectedMoviesInScreens[screen].movies[movie]);
        this.dropLocationClone = this.dropLocation;
        this.draggedObject.screen = screen;
        this.draggedObject.movie = movie;
        this.draggedObject.oldStart = this.selectedMoviesInScreens[
          screen
        ].movies[movie].start;
        this.draggedObject.length = this.selectedMoviesInScreens[screen].movies[
          movie
        ].length;
        this.draggedObject.md_thumbnail_url = this.selectedMoviesInScreens[
          screen
        ].movies[movie].md_thumbnail_url;
        // md_thumbnail_url: y.md_thumbnail_url,
        this.draggedObject.lengthMinutes = this.selectedMoviesInScreens[
          screen
        ].movies[movie].lengthMinutes;
        this.selectedMovieIndex = movie;

        //check if the drop is overlapping with something else
        //if no overlap,delete old object, else
        //add object to new place
        // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 0;
      },
      endDrag: function(data) {
        // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 99;
      },

      checkOverLapMovie: function(movie, screen) {
        let overlap = {
          status: false,
          screen: screen,
          movie: {},
        };
        if (screen != null || screen != -1) {
          console.log("screen111", screen);
          this.selectedMoviesInScreens[screen].movies.map(
            (otherMovie, index) => {
              console.log(otherMovie);
              if (otherMovie.isNewSchedule) {
                console.log("screen111222", otherMovie);

                let scheduleShowPriceObj = {
                  rate_card_id: null,
                  schedule_show_id: null,
                  screen_seat_type_id: null,
                  p_start_date_time: null,
                  p_end_date_time: null,
                  p_is_active: "Y",
                };

                otherMovie[0] = { scheduleShowPrice: scheduleShowPriceObj };
              }

              let startCheck = this.newGetScreenPositionCalc(
                this.dropLocation.hour,
                this.dropLocation.minute
              );
              // let startCheck =
              //   (this.dropLocation.hour - 1) * 180 +
              //   (this.dropLocation.minute - 1) * 30;
              if (
                movie.start < otherMovie.start &&
                !(movie.start + movie.length < otherMovie.start)
              ) {
                console.log("overlap new movie2");
                this.$toasted.show("Movie Overlapped 1");
                overlap.status = true;
                overlap.movie = otherMovie;
              }

              if (
                movie.start > otherMovie.start &&
                movie.start < otherMovie.start + otherMovie.length &&
                movie.start != otherMovie.start + otherMovie.length
              ) {
                this.$toasted.show("Movie Overlapped 2");
                console.log("overlap new movie1");
                overlap.status = true;
                overlap.movie = otherMovie;
              }
              // if (otherMovie.movie_details_id == data.movie.md_id) {
              //   let scheduleShowPriceObj = {
              //     rate_card_id: 1,
              //     schedule_show_id: "1",
              //     screen_seat_type_id: "18",
              //     p_start_date_time: 1,
              //     p_end_date_time: 1,
              //     p_is_active: "Y"
              //   };
              //   otherMovie.push({ scheduleShowPrice: scheduleShowPriceObj });
              // }
            }
          );

          // if (
          //     this.draggedObject.newStart < otherMovie.start &&
          //     !(
          //       this.draggedObject.newStart + draggedMovie.length <
          //       otherMovie.start
          //     )
          //   ){

          //   }
          return overlap;
        } else {
          return overlap;
        }
        return overlap;
      },
      endTimeCalcutor: function(startTime, minutes) {
        let hoursMain = startTime.split(":")[0];
        let minutesMain = startTime.split(":")[1];
        let hMinutes = Math.floor(minutes / 60);
        hoursMain = parseInt(hoursMain) + parseInt(hMinutes);
        minutesMain = parseInt(minutes % 60) + parseInt(minutesMain);
        if (minutesMain >= 60) {
          minutesMain = minutesMain - 60;
          hoursMain++;
        }
        if (minutesMain < 10) {
          minutesMain = "0" + minutesMain.toString();
        }
        if (hoursMain > 23) {
          hoursMain = hoursMain - 24;
        }
        if (hoursMain < 10) {
          hoursMain = "0" + hoursMain.toString();
        }
        return `${hoursMain}:${minutesMain}`;
      },
      createMovie: function(movie, screen) {
        console.log(
          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3339 ~ movie",
          movie
        );
        if (screen != -1) {
          this.selectedScreenIndex = screen;

          this.selectedScreenSeatTypes = this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].screen_seat_types;
          let seat_type_length = this.selectedScreenSeatTypes.length;
          let obj = undefined;

          let scheduleShowPriceObj = {
            rate_card_id: null,
            schedule_show_id: null,
            screen_seat_type_id: null,
            p_start_date_time: null,
            p_end_date_time: null,
            p_is_active: "Y",
            rc_name: "",
            searchRateCard: "",
          };

          let scheduleShowPriceArray = [];
          for (var i = 0; i < seat_type_length; i++) {
            scheduleShowPriceArray.push(_.cloneDeep(scheduleShowPriceObj));
          }

          this.selectedMoviesInScreens[screen].movies.push({
            length: movie.length,
            lengthMinutes: movie.lengthMinutes,
            movie_id: movie.movie_id,
            lang_iso_2: movie.lang_iso_2,
            sub_lang_1_iso_2: movie.sub_lang_1_iso_2,
            sub_lang_2_iso_2: movie.sub_lang_2_iso_2,
            sub_lang_1_iso_3: movie.sub_lang_1_iso_3,
            sub_lang_2_iso_3: movie.sub_lang_2_iso_3,
            movie_details_id: movie.md_id || movie.movie_details_id,
            start: movie.start,
            end_time: this.endTimeCalcutor(
              this.dropLocation.time,
              movie.lengthMinutes
            ),
            cine_cleaning_time_in_mins: this.CinemasSettings
              .cine_cleaning_time_in_mins,
            cine_setting_ads_time_in_mins: this.CinemasSettings
              .cine_setting_ads_time_in_mins,
            cine_interval_time_in_mins: this.CinemasSettings
              .cine_interval_time_in_mins,
            // start: this.getScreenPositionCalc(this.dropLocation.hour),
            // start:
            //   (this.dropLocation.hour - 1) * 180 +
            //   (this.dropLocation.minute - 1) * 30,
            zIndex: 99,
            mf_name: movie.mf_name,
            md_thumbnail_url: movie.md_thumbnail_url,
            lang_name: movie.lang_name,
            movie_title: movie.movie_title,
            movie: movie.movie_name,
            start_time: this.dropLocation.time,
            isNewSchedule: movie.isNewSchedule == false ? false : true,
            show_schedule_id: movie.show_schedule_id || null,
            scheduleShowPrice: scheduleShowPriceArray,
            ss_show_status: 16,
            mycinema_booking_type_id: movie.mycinema_booking_type_id,
          });

          console.log(
            "this.selectedMoviesInScreens[screen].movies after latest push =>>>>",
            _.cloneDeep(this.selectedMoviesInScreens[screen].movies)
          );

          console.log("this.selectedMovieIndex", this.selectedMovieIndex);

          let movies_length_for_this_screen = this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].movies.length;

          if (
            this.selectedMovieIndex != null &&
            this.dropLocation.screen == this.selectedScreenIndex &&
            this.selectedMoviesInScreens[this.dropLocation.screen].movies
              .length > 0 &&
            this.selectedMoviesInScreens[this.dropLocation.screen].movies[
              this.selectedMovieIndex
            ] &&
            this.selectedMoviesInScreens[this.dropLocation.screen].movies[
              this.selectedMovieIndex
            ].hasOwnProperty("scheduleShowPrice") &&
            this.selectedMoviesInScreens[this.dropLocation.screen].movies[
              this.selectedMovieIndex
            ].scheduleShowPrice.length > 0
          ) {
            let prev_obj = this.selectedMoviesInScreens[
              this.dropLocation.screen
            ].movies[this.selectedMovieIndex];
            obj = prev_obj.scheduleShowPrice;

            let prev_show_status = prev_obj.ss_show_status;

            this.selectedMoviesInScreens[this.dropLocation.screen].movies[
              movies_length_for_this_screen - 1
            ] = {
              ...this.selectedMoviesInScreens[this.dropLocation.screen].movies[
                movies_length_for_this_screen - 1
              ],
              scheduleShowPrice: _.cloneDeep(obj),
              isReady: this.selectedMoviesInScreens[this.dropLocation.screen]
                .movies[this.selectedMovieIndex].isReady,
              ss_show_status: prev_show_status,
            };
          }

          this.selectedMovieIndex = movies_length_for_this_screen - 1;

          // this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
          //   (x, index) => {
          //     if (x.isNewSchedule) {
          //       this.selectedMovieIndex = index;
          //       let scheduleShowPriceObj = {
          //         rate_card_id: null,
          //         schedule_show_id: null,
          //         screen_seat_type_id: null,
          //         p_start_date_time: null,
          //         p_end_date_time: null,
          //         p_is_active: "Y",
          //         rc_name: "",
          //         searchRateCard: ""
          //       };
          //       let scheduleShowPriceArray = [];
          //       for (var i = 0; i < seat_type_length; i++) {
          //         scheduleShowPriceArray.push(scheduleShowPriceObj);
          //       }
          //       Object.assign(x, {
          //         scheduleShowPrice: obj ? [...obj] : scheduleShowPriceArray
          //       });
          //     }
          //     //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
          //   }
          // );
          this.onSelectMovie(null, screen, this.selectedMovieIndex);
        }
        this.dropLocation.screen = "-1";
      },
      dragEnter: debounce(function(
        screen,
        hour,
        minute,
        hourIndex,
        drop_date_time,
        movieData
      ) {
        console.log("dragEnter function is called 3763");
        this.dropLocation.screen = screen;
        this.dropLocation.hour = hour;
        this.dropLocation.hourIndex = hourIndex;
        this.dropLocation.minute = minute - 1;
        this.dropLocation.drop_date_time = drop_date_time;
        // console.log(hour.split(":")[0])

        if (movieData && movieData.type === "newMovie") {
          this.selectedMovieIndex = null;
        }

        // done positionLeft = based on the distance from left considering the cinema open time and the time after 12AM
        let cinemaStartReduce =
          parseInt(
            this.CinemasSettings.cine_operation_start_time.split(":")[0]
          ) * 60;
        // this.dropLocation.positionLeft = parseInt(hourIndex)*50 + (this.dropLocation.minute)*50/6- (cinemaStartReduce/60)*50;
        this.dropLocation.positionLeft =
          parseInt(hour.split(":")[0]) * 50 +
          (this.dropLocation.minute * 50) / 6 -
          (cinemaStartReduce / 60) * 50;
        // this.dropLocation.positionLeft = parseInt(hour.split(":")[0])*60 + (this.dropLocation.minute-cinemaStartReduce)*50/6;
        // this.dropLocation.time = hour.split(":")[0] + ":";

        this.dropLocation.positionLeft = this.newGetScreenPositionCalc(
          hour,
          this.dropLocation.minute * 10
        );
        //TODO add end time in hours
        this.dropLocation.positionLeftEndTime = this.newGetScreenPositionCalc(
          hour,
          this.dropLocation.minute * 10
        );
        // console.log("droplocation", this.dropLocation.positionLeft);
        if (this.dropLocation.minute > 0) {
          this.dropLocation.time =
            hour.split(":")[0] + ":" + this.dropLocation.minute * 10;
        } else {
          this.dropLocation.time = hour.split(":")[0] + ":00";
        }
        // console.log("time", this.dropLocation.time);

        // this.dropLocation.minute = minute;
      },
      20),
      openEditPopUp: function() {
        alert("popup");
      },
      onSelectMovie: function(event, screenIndex, movieIndex) {
        console.log(
          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3814 ~ movieIndex",
          movieIndex
        );
        console.log(
          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3814 ~ screenIndex",
          screenIndex
        );

        this.clickSelectedMovies = [];
        this.selectedScreenIndex = screenIndex;
        this.selectedMovieIndex = movieIndex;
        this.selectedScreenSeatTypes = this.selectedMoviesInScreens[
          screenIndex
        ].screen_seat_types;
        this.movieSelected = this.selectedMoviesInScreens[screenIndex].movies[
          movieIndex
        ];
        this.movieSelected = this.selectedMoviesInScreens[screenIndex].movies[
          movieIndex
        ];
        console.log("this.movieSelected", this.movieSelected);
        let tempMoviesObject = this.selectedMoviesInScreens[screenIndex];
        if (!tempMoviesObject.movies[movieIndex].selected) {
          tempMoviesObject.movies[movieIndex].selected = true;
        } else {
          tempMoviesObject.movies[movieIndex].selected = !tempMoviesObject
            .movies[movieIndex].selected;
        }
        if (tempMoviesObject.movies[movieIndex].selected == true) {
          this.clickSelectedMovies.push({
            screenIndex: screenIndex,
            movieIndex: movieIndex,
          });
        }
        this.isMovieCardSelected = true;

        console.log(
          "this.selectedMoviesInScreens :>> ",
          this.selectedMoviesInScreens
        );

        VueMain.set(
          this.selectedMoviesInScreens,
          screenIndex,
          tempMoviesObject
        );
        console.log(
          "this.selectedMoviesInScreens :>> ",
          this.selectedMoviesInScreens
        );

        setTimeout((x) => {
          this.selectedMoviesInScreens.map((x, index1) => {
            if (x.movies.length > 0) {
              x.movies.map((y, index2) => {
                // console.log(y,index2==movieIndex,index2,movieIndex,index1==screenIndex,index1,screenIndex)
                if (index1 == screenIndex && index2 == movieIndex) {
                  let selectedStatus = this.scheduleStatusArray.filter(
                    (x) => x.status_id == y.ss_show_status
                  );

                  this.selectedStatus = selectedStatus[0].type;

                  if (y.isNewSchedule) {
                    // alert(y.movie_title);
                    y.selected = true;
                    y.movie_title = y.movie_title + " ";

                    let arrayMap = this.selectedMoviesInScreens[screenIndex][
                      "screen_seat_card_mapping"
                    ];

                    let mapping_array = [];
                    arrayMap.map((z) => {
                      let rateCardStartTime = moment(
                        z.start_time,
                        "HH:mm"
                      ).format("DD-MM-YYYY HH:mm");

                      let rateCardEndTime = "";
                      if (
                        moment(z.end_time, "HH:mm").isBefore(
                          moment(z.start_time, "HH:mm")
                        )
                      ) {
                        rateCardEndTime = moment(z.end_time, "HH:mm")
                          .add(1, "days")
                          .format("DD-MM-YYYY HH:mm");
                      } else {
                        rateCardEndTime = moment(z.end_time, "HH:mm").format(
                          "DD-MM-YYYY HH:mm"
                        );
                      }
                      let startMovieTime = moment(y.start_time, "HH:mm").format(
                        "DD-MM-YYYY HH:mm"
                      );

                      // let range = [z.start_time, z.end_time];
                      // if (y.start_time >= range[0] && y.start_time <= range[1]) {
                      if (
                        startMovieTime >= rateCardStartTime &&
                        startMovieTime <= rateCardEndTime
                      ) {
                        mapping_array.push(z);
                      } else {
                      }
                    });

                    if (mapping_array.length > 0) {
                      let newDate = new Date(
                        this.scheduleObject.sch_start_date
                      ).getDay();

                      let arrayDays = [
                        {
                          day: "is_sunday",
                          checkDay: 0,
                        },
                        {
                          day: "is_monday",
                          checkDay: 1,
                        },
                        {
                          day: "is_tuesday",
                          checkDay: 2,
                        },
                        {
                          day: "is_wednesday",
                          checkDay: 3,
                        },
                        {
                          day: "is_thursday",
                          checkDay: 4,
                        },
                        {
                          day: "is_friday",
                          checkDay: 5,
                        },
                        {
                          day: "is_saturday",
                          checkDay: 6,
                        },
                      ];

                      let checkInd = arrayDays.findIndex((days) => {
                        return days.checkDay == newDate;
                      });
                      // console.log(newDate,"date",arrayDays[checkInd].day)
                      x.screen_seat_types.map((seat_types, screenTypeIndex) => {
                        let arrayMapping = mapping_array.filter((st) => {
                          return (
                            st.screen_seat_type_id == seat_types.sst_id &&
                            st[arrayDays[checkInd].day] == "Y"
                          );
                        });
                        console.log(
                          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3589 ~ x.screen_seat_types.map ~ arrayMapping",
                          arrayMapping
                        );

                        console.log(
                          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3597 ~ x.screen_seat_types.map ~ this.RatecardsList",
                          this.RatecardsList
                        );
                        if (arrayMapping.length > 0) {
                          arrayMapping.map((card) => {
                            let findIndexNew = this.RatecardsList.findIndex(
                              (r_c) => {
                                console.log(card, r_c, "sdfsdf", r_c.rc_g_id);
                                return card.rate_card_id == r_c.rc_g_id;
                              }
                            );
                            console.log(findIndexNew, card, card.rate_card_id);
                            if (
                              findIndexNew >= 0 &&
                              (this.selectedMoviesInScreens[screenIndex][
                                "movies"
                              ][movieIndex]["scheduleShowPrice"][
                                screenTypeIndex
                              ].rate_card_id == "" ||
                                this.selectedMoviesInScreens[screenIndex][
                                  "movies"
                                ][movieIndex]["scheduleShowPrice"][
                                  screenTypeIndex
                                ].rate_card_id == null)
                            ) {
                              console.log("fdsfsdfsdfsdfsd");
                              this.onSelectScreenType(screenTypeIndex);
                              this.onSelectRateCard(
                                screenTypeIndex,
                                seat_types,
                                this.RatecardsList[findIndexNew]
                              );
                            } else {
                              console.log("2");
                              this.onDefaultRateCardEmpty(
                                screenIndex,
                                movieIndex,
                                screenTypeIndex
                              );
                            }
                          });
                        } else {
                          console.log("1");
                          this.onDefaultRateCardEmpty(
                            screenIndex,
                            movieIndex,
                            screenTypeIndex
                          );
                        }
                      });
                    }
                  } else {
                    x.screen_seat_types.map((seat_types, screenTypeIndex) => {
                      console.log(seat_types);
                      let filterArrr = y.scheduleShowPrice.filter((kk) => {
                        return seat_types.sst_id == kk.screen_seat_type_id;
                      });
                      console.log(filterArrr);
                      if (filterArrr.length > 0) {
                        let RateCardCheckInd = this.RatecardsList.findIndex(
                          (rc_card) => {
                            return (
                              filterArrr[0].rate_card_group_id ==
                              rc_card.rc_g_id
                            );
                          }
                        );

                        console.log(RateCardCheckInd);
                        if (RateCardCheckInd >= 0) {
                          this.onSelectScreenType(screenTypeIndex);
                          this.onSelectRateCard(
                            screenTypeIndex,
                            seat_types,
                            this.RatecardsList[RateCardCheckInd]
                          );
                        }
                      }
                    });
                  }
                } else {
                  y.selected = false;
                  y.movie_title = y.movie_title.trim();
                }
              });
            }
          });
        }, 200);

        // if(this.selectedMoviesInScreens[screenIndex].movies[movieIndex].selected==false || !this.selectedMoviesInScreens[screenIndex].movies[movieIndex].selected){
        //   this.selectedMoviesInScreens[screenIndex].movies[movieIndex].selected = true;
        //   this.clickSelectedMovies.push({ screenIndex:screenIndex, movieIndex:movieIndex })
        // }
        // if(this.selectedMoviesInScreens[screenIndex].movies[movieIndex].selected == true){
        //   this.selectedMoviesInScreens[screenIndex].movies[movieIndex].selected = false;
        // }
      },
      getShowDateTimeWithOnlyShowtime: function(showtime) {
        let final_show_time = moment(showtime, "HH:mm");

        if (
          final_show_time.isSameOrAfter(
            moment(moment().format("YYYY-MM-DD 00:00"))
          ) &&
          final_show_time.isSameOrBefore(
            moment(this.CinemasSettings.cine_operation_start_time, "HH:mm")
          )
        ) {
          final_show_time.add(1, "d");
        }

        return final_show_time;
      },
      checkOverlapUsingShowtimes: function(
        new_start_date_time,
        new_end_date_time,
        movieIndex,
        screenIndex
      ) {
        let screen = this.selectedMoviesInScreens[screenIndex];
        let doesOverlap = false;
        for (let [mIndex, movie] of screen.movies.entries()) {
          if (mIndex != movieIndex) {
            let movie_start_date_time = moment(
              this.getShowDateTimeWithOnlyShowtime(movie.start_time).format(
                "YYYY-MM-DD"
              ) +
                " " +
                movie.start_time,
              "YYYY-MM-DD HH:mm"
            );

            let movie_end_date_time = moment(
              this.getShowDateTimeWithOnlyShowtime(movie.end_time).format(
                "YYYY-MM-DD"
              ) +
                " " +
                movie.end_time,
              "YYYY-MM-DD HH:mm"
            );

            if (
              new_start_date_time.isSameOrAfter(movie_start_date_time) &&
              new_start_date_time.isSameOrBefore(movie_end_date_time)
            ) {
              doesOverlap = true;
            } else if (
              new_end_date_time.isSameOrAfter(movie_start_date_time) &&
              new_end_date_time.isSameOrBefore(movie_end_date_time)
            ) {
              doesOverlap = true;
            }
          }
        }

        return doesOverlap;
      },
      arrowLeftRight: function() {
        event.preventDefault();

        console.log("coming to arrowLeftRight");

        this.clickSelectedMovies.map((movieIndexes, index) => {
          let start_time = moment(this.movieSelected.start_time, "HH:mm");
          let end_time = moment(this.movieSelected.end_time, "HH:mm");

          let start_date_time = moment(start_time);
          let end_date_time = moment(end_time);

          if (event.keyCode == 37) {
            start_date_time.subtract(10, "minutes");
            end_date_time.subtract(10, "minutes");
          } else if (event.keyCode == 39) {
            start_date_time.add(10, "minutes");
            end_date_time.add(10, "minutes");
          }

          if (
            start_time.isSameOrAfter(
              moment(moment().format("YYYY-MM-DD 00:00"))
            ) &&
            start_time.isSameOrBefore(
              moment(this.CinemasSettings.cine_operation_end_time, "HH:mm")
            )
          ) {
            start_date_time.add(1, "d");
          }

          if (
            end_date_time.isSameOrAfter(
              moment(moment().format("YYYY-MM-DD 00:00"))
            ) &&
            end_date_time.isSameOrBefore(
              moment(this.CinemasSettings.cine_operation_start_time, "HH:mm")
            )
          ) {
            end_date_time.add(1, "d");
          }

          if (event.keyCode == 37) {
            let doesOverlap = this.checkOverlapUsingShowtimes(
              start_date_time,
              end_date_time,
              movieIndexes.movieIndex,
              movieIndexes.screenIndex
            );

            if (!doesOverlap) {
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start =
                this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                  movieIndexes.movieIndex
                ].start -
                50 / 6;
              let new_start_time = start_time
                .subtract(10, "minutes")
                .format("HH:mm");
              let new_end_time = end_time
                .subtract(10, "minutes")
                .format("HH:mm");
              this.movieSelected.start_time = new_start_time;
              this.movieSelected.end_time = new_end_time;
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start_time = new_start_time;
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].end_time = new_end_time;

              if (
                this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                  movieIndexes.movieIndex
                ].start < 0
              ) {
                this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                  movieIndexes.movieIndex
                ].start = 0;
                this.movieSelected.start_time = this.CinemasSettings.cine_operation_start_time;
                this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                  movieIndexes.movieIndex
                ].start_time = this.CinemasSettings.cine_operation_start_time;
              }
            } else {
              this.$toasted.show("Overlap");
            }
          } else if (event.keyCode == 39) {
            let doesOverlap = this.checkOverlapUsingShowtimes(
              start_date_time,
              end_date_time,
              movieIndexes.movieIndex,
              movieIndexes.screenIndex
            );

            if (!doesOverlap) {
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start =
                this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                  movieIndexes.movieIndex
                ].start +
                50 / 6;
              let new_start_time = start_time
                .add(10, "minutes")
                .format("HH:mm");
              let new_end_time = end_time.add(10, "minutes").format("HH:mm");
              this.movieSelected.start_time = new_start_time;
              this.movieSelected.end_time = new_end_time;
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start_time = new_start_time;
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].end_time = new_end_time;
            } else {
              this.$toasted.show("Overlap");
            }
          }
        });
      },
      getCinemaEndDateTime: function() {
        let cinema_closing_date_time = moment(
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_end_time,
          "YYYY-MM-DD HH:mm"
        );

        console.log(
          cinema_closing_date_time,
          "sdfsdfsdfsdf",
          this.scheduleObject.sch_start_date
        );
        if (
          moment(
            moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isSameOrBefore(
            moment(
              moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
                " " +
                this.CinemasSettings.cine_operation_start_time
            )
          )
        ) {
          cinema_closing_date_time = moment(
            moment(this.scheduleObject.sch_start_date)
              .add(1, "d")
              .format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time,
            "YYYY-MM-DD HH:mm"
          );
        }

        return cinema_closing_date_time;
      },
      handleDrop: function(data, event) {
        console.log({ data });
        console.log(
          "existing movies in handle drop =>>>>>",
          this.selectedMoviesInScreens
        );
        console.log("this.dropLocation.screen", this.dropLocation.screen);
        console.log(
          "this.dropLocation in handleDrop =>>>>>>",
          this.dropLocation
        );
        console.log(
          "this.scheduleObject.sch_start_date in handleDrop =>>>>>>",
          this.scheduleObject.sch_start_date
        );
        console.log(
          "this.scheduleObject in handleDrop =>>>>>>",
          this.scheduleObject
        );

        let targetScreenIndex = this.dropLocation.screen;
        console.log(
          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4142 ~ targetScreenIndex",
          targetScreenIndex
        );

        if (data && data.isNoRuntime) {
          this.$toasted.show("Cannot schedule a movie without a Runtime");
          this.dropLocation.screen = -1;
          return;
        }

        let cinema_closing_date_time = this.getCinemaEndDateTime();
        console.log(
          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4046 ~ cinema_closing_date_time",
          cinema_closing_date_time
        );
        let movie_schedule_time = moment(
          this.dropLocation.drop_date_time,
          "YYYY-MM-DD HH:mm"
        );

        console.log(
          "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4048 ~ movie_schedule_time",
          movie_schedule_time,
          cinema_closing_date_time
        );

        if (movie_schedule_time.isSameOrAfter(cinema_closing_date_time)) {
          this.$toasted.show(
            "Cannot schedule a movie after cinema closing time. Cinema closing time is: " +
              this.CinemasSettings.cine_operation_end_time
          );
          this.dropLocation.screen = -1;
          return;
        }

        let movieTime = moment(
          `${this.dropLocation.hour.split(":")[0]}:${this.dropLocation.minute *
            10}`,
          "HH:mm"
        );

        if (movieTime.isValid()) {
          let currTime = moment();
          // let currDate = currTime.format("DD-MM-YYYY");
          // let movieDate = moment(this.scheduleObject.sch_start_date).format(
          //   "DD-MM-YYYY"
          // );
          let movieDateTime = moment(
            this.dropLocation.drop_date_time,
            "YYYY-MM-DD HH:mm"
          );

          if (
            moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") ===
              currTime.format("YYYY-MM-DD") &&
            movieDateTime.isBefore(currTime)
          ) {
            this.$toasted.show("Cannot schedule movie in past time");
            this.dropLocation.screen = "-1";
            return false;
          }
        }

        this.isChanged = true;

        // console.log("data, event :", data, event);
        //check if overlap with something else
        let draggedMovie = data.movie;
        draggedMovie.start = this.dropLocation.positionLeft; // console.log("this.draggedObject :", this.draggedObject);

        // If yes, then remove old position of movie, if 1 do nothing, else copy/move
        let createMovie = 0;

        if (this.dropLocation.screen >= 0) {
          let screen_id = parseInt(this.dropLocation.screen);

          if (this.selectedMoviesInScreens[screen_id].totalSeatLayout <= 0) {
            this.$toasted.show(
              `No Seat Layout for screen ${this.selectedMoviesInScreens[screen_id]["screen_name"]}`
            );
            return false;
          }
        }
        if (this.dropLocation.screen >= 0) {
          let movie = data.movie;
          let movieType = data.type;
          let screen_id_index = parseInt(this.dropLocation.screen);
          let screen = this.selectedMoviesInScreens[screen_id_index];

          if (screen.videoFormats && movie.mf_id) {
            let videoFormats = screen.videoFormats.map((vf) => vf.mf_id);
            console.log({ videoFormats, mf_id: movie.mf_id });

            if (!videoFormats.includes(movie.mf_id)) {
              this.$toasted.show(
                `${
                  this.selectedMoviesInScreens[screen_id_index]["screen_name"]
                } ${this.$t("videoFormatErrorPopup")}`
              );
              this.dropLocation.screen = "-1";
              return false;
            }
          }
        }
        if (this.dropLocation.screen >= 0) {
          let movie = data.movie;
          let movieType = data.type;
          let screen_id_index = parseInt(this.dropLocation.screen);
          let screen = this.selectedMoviesInScreens[screen_id_index];

          if (
            screen.soundFormats &&
            screen.soundFormats.length &&
            movie.sound_format_id
          ) {
            let soundFormats = screen.soundFormats.map(
              (sf) => sf.sound_format_id
            );
            console.log({
              soundFormats,
              sound_format_id: movie.sound_format_id,
            });

            if (!soundFormats.includes(movie.sound_format_id)) {
              this.$toasted.show(
                `${
                  this.selectedMoviesInScreens[screen_id_index]["screen_name"]
                } ${this.$t("soundFormatErrorPopup")}`
              );
              this.dropLocation.screen = "-1";
              return false;
            }
          }
        }
        if (this.dropLocation.screen >= 0) {
          let movie = data.movie;
          let movieType = data.type;
          let screen_id_index = parseInt(this.dropLocation.screen);
          let screen = this.selectedMoviesInScreens[screen_id_index];

          if (
            movie.hasOwnProperty("mss_ss_start_date") &&
            movie.hasOwnProperty("mss_ss_end_date")
          ) {
            if (!movie.mss_ss_start_date || !movie.mss_ss_end_date) {
              this.$toasted.show(`${this.$t("licenseDateErrorPopup")}`);
              // this.dropLocation.screen = "-1";
              // return false;
            }

            if (!!this.scheduleObject.sch_start_date) {
              let schStartDate = moment(this.scheduleObject.sch_start_date);
              let licStartDate = moment(movie.mss_ss_start_date);
              let licEndDate = moment(movie.mss_ss_end_date);

              console.log({
                schStartDate: schStartDate.format("DD-MM-YYYY"),
                licStartDate: licStartDate.format("DD-MM-YYYY"),
                licEndDate: licEndDate.format("DD-MM-YYYY"),
              });

              if (
                !schStartDate.isBetween(licStartDate, licEndDate, "days", "[]") // all inclusive
              ) {
                console.log("Start date is not between licStart, licEnd");
                this.$toasted.show(`${this.$t("licenseDateErrorPopup")}`);
                // this.dropLocation.screen = "-1";
                // return false;
              }
            }
          }
        }

        let overlap = this.checkOverLapMovie(
          draggedMovie,
          this.dropLocation.screen
        );
        // console.log("overlap :>> ", overlap);

        if (overlap.status) {
          let indexNew = parseInt(overlap.screen);
          if (indexNew >= 0) {
            console.log(
              this.selectedMoviesInScreens[indexNew],
              "fdsfdsfds",
              data.movie
            );
            let findIndexMovies = this.selectedMoviesInScreens[
              indexNew
            ].movies.findIndex((xMovies) => {
              return (
                xMovies.movie_details_id == data.movie.movie_details_id &&
                xMovies.start_time == data.movie.start_time
              );
            });
            console.log(findIndexMovies, "Index");
            if (findIndexMovies >= 0) {
              console.log(
                this.draggedObject,
                this.selectedMoviesInScreens[indexNew]["movies"][
                  findIndexMovies
                ],
                "==="
              );
              this.selectedMoviesInScreens[indexNew]["movies"][findIndexMovies][
                "start"
              ] = this.draggedObject.oldStart;

              // this.selectedMoviesInScreens[indexNew]["movies"].splice(
              //   findIndexMovies,
              //   1
              // );
            }
          }

          console.log("overlap.movie", overlap.movie);
          this.dropLocation = this.dropLocationClone;
          this.$toasted.show(
            `Movie Overlapped with ${overlap.movie.movie_title} starting at ${overlap.movie.start_time} and ending at  ${overlap.movie.end_time}`
          );
          this.dropLocation.screen = -1;

          return;
          //TO DO show toast message
          // alert('overlap new'+ this.dropLocation.screen+JSON.stringify(draggedMovie))
        } else {
          console.log("else");
          this.createMovie(draggedMovie, this.dropLocation.screen);
          if (data.type == "presentMovie") {
            //Delete original Movie

            console.log(
              "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4301 ~ this.draggedObject.screen",
              this.draggedObject.screen
            );

            let tempMoviesObject = this.selectedMoviesInScreens[
              this.draggedObject.screen
            ];

            tempMoviesObject.movies.splice(this.draggedObject.movie, 1);

            this.selectedMovieIndex =
              this.selectedMoviesInScreens[targetScreenIndex].movies.length - 1;

            console.log(
              "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4294 ~ this.selectedMovieIndex",
              this.selectedMovieIndex
            );

            this.onSelectMovie(
              null,
              targetScreenIndex,
              this.selectedMovieIndex
            );

            VueMain.set(
              this.selectedMoviesInScreens,
              this.draggedObject.screen,
              tempMoviesObject
            );
            this.$forceUpdate();
          }

          console.log(
            "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4306 ~ this.dropLocation.screen",
            this.dropLocation.screen
          );

          console.log(
            "🚀 ~ file: ViewScheduleDD-1.vue ~ line 4308 ~ this.selectedMoviesInScreens",
            this.selectedMoviesInScreens
          );
        }

        console.log("return");
        this.dropLocation.screen = -1;
        // start
        return;
        // OLD CODE
        // let draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
        // .movies[this.draggedObject.movie];

        //if movie already is in screen and you are moving
        if (data.type == "presentMovie") {
          console.log("else1");
          //select the movie being dragged
          draggedMovie = this.selectedMoviesInScreens[this.draggedObject.screen]
            .movies[this.draggedObject.movie];

          this.draggedObject.newStart = this.getScreenPositionCalc(
            this.dropLocation.hour
          );
          // this.draggedObject.newStart =
          //   (this.dropLocation.hour - 1) * 180 +
          //   (this.dropLocation.minute - 1) * 30;
          this.selectedMoviesInScreens[this.draggedObject.screen].movies[
            this.draggedObject.movie
          ].zIndex = 0;

          //loop through all movies to make sure no overlap
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (otherMovie, index) => {
              //compare with start and start + length

              // draggedMoviestart > oldMovie start+length || draggedMoviestart +length < oldMovie start

              // if (
              //   this.draggedObject.newStart > otherMovie.start &&
              //   !(
              //     otherMovie.start + otherMovie.length <
              //     this.draggedObject.newStart
              //   )
              // ) {
              //   createMovie = 1;
              //   alert("overlap1");
              // }
              if (
                this.draggedObject.newStart < otherMovie.start &&
                !(
                  this.draggedObject.newStart + draggedMovie.length <
                  otherMovie.start
                )
              ) {
                createMovie = 1;
                this.$toasted.show("Movie Overlapped 4");
                // alert("overlap old movie");
                if (
                  this.dropLocation.screen == this.draggedObject.screen &&
                  this.draggedObject.movie == index
                ) {
                  createMovie = 0;
                }
              }

              // if (
              //   draggedMovie.start >
              //     parseInt(otherMovie.start) + parseInt(otherMovie.length) ||
              //   parseInt(draggedMovie.start) + parseInt(draggedMovie.length) <
              //     otherMovie.start
              // ) {
              //   createMovie = 1;
              //   alert("overlap");
              // }
            }
          );
        }
        //Drop New Movie
        if (data.type == "newMovie") {
          console.log("else2");

          //loop through all movies to make sure no overlap
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (otherMovie, index) => {
              let scheduleShowPriceObj = {
                rate_card_id: null,
                schedule_show_id: null,
                screen_seat_type_id: null,
                p_start_date_time: null,
                p_end_date_time: null,
                p_is_active: "Y",
                searchRateCard: "",
              };
              otherMovie[0] = { scheduleShowPrice: scheduleShowPriceObj };
              let startCheck = this.getScreenPositionCalc(
                this.dropLocation.hour
              );
              // let startCheck =
              //   (this.dropLocation.hour - 1) * 180 +
              //   (this.dropLocation.minute - 1) * 30;
              if (
                startCheck < otherMovie.start &&
                !(startCheck + draggedMovie.length < otherMovie.start)
              ) {
                createMovie = 1;
                this.$toasted.show("Movie Overlapped 5");
                // alert("overlap new movie");
              }
              // if (otherMovie.movie_details_id == data.movie.md_id) {
              //   let scheduleShowPriceObj = {
              //     rate_card_id: 1,
              //     schedule_show_id: "1",
              //     screen_seat_type_id: "18",
              //     p_start_date_time: 1,
              //     p_end_date_time: 1,
              //     p_is_active: "Y"
              //   };
              //   otherMovie.push({ scheduleShowPrice: scheduleShowPriceObj });
              // }
            }
          );
        }

        //create new movie
        if (createMovie == 0) {
          console.log("else4");
          // this.selectedMoviesInScreens[
          //   this.dropLocation.screen
          // ].movies = this.selectedMoviesInScreens[
          //   this.dropLocation.screen
          // ].movies.filter((movie, index) => {
          //   console.log("lastCheck", movie);
          //   // if (movie.zIndex == 99) return movie;
          //   return movie.zIndex == 99;
          // });
          // let dropScreen;
          // if(data.type == "presentMovie"){
          //   dropScreen = this.draggedObject.screen;
          // }else if (data.type == "newMovie"){
          //   dropScreen = this.dropLocation.screen;
          // }
          // console.log

          this.selectedMoviesInScreens[this.dropLocation.screen].movies.push({
            length: draggedMovie.length,
            lengthMinutes: draggedMovie.lengthMinutes,
            movie_details_id: draggedMovie.md_id,
            movie_id: draggedMovie.movie_id,
            start: this.dropLocation.positionLeft,
            // start: this.getScreenPositionCalc(this.dropLocation.hour),
            // start:
            //   (this.dropLocation.hour - 1) * 180 +
            //   (this.dropLocation.minute - 1) * 30,
            zIndex: 99,
            mf_name: draggedMovie.mf_name,
            md_thumbnail_url: draggedMovie.md_thumbnail_url,
            lang_name: draggedMovie.lang_name,
            movie_title: draggedMovie.movie_title,
          });
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
            (x) => {
              let scheduleShowPriceObj = {
                rate_card_id: null,
                schedule_show_id: null,
                screen_seat_type_id: null,
                p_start_date_time: null,
                p_end_date_time: null,
                p_is_active: "Y",
                searchRateCard: "",
              };
              let scheduleShowPriceArray = [];
              scheduleShowPriceArray.push(scheduleShowPriceObj);
              Object.assign(x, { scheduleShowPrice: scheduleShowPriceArray });
              //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
            }
          );
        }
        if (createMovie == 1 && data.type != "newMovie") {
          console.log("elseasa");
          this.selectedMoviesInScreens[this.draggedObject.screen].movies.push({
            length: draggedMovie.length,
            lengthMinutes: draggedMovie.lengthMinutes,
            movie_id: draggedMovie.movie_id,
            movie_details_id: draggedMovie.md_id,
            start: draggedMovie.start,
            zIndex: 99,
            mf_name: draggedMovie.mf_name,
            md_thumbnail_url: draggedMovie.md_thumbnail_url,
            lang_name: draggedMovie.lang_name,
            movie_title: draggedMovie.movie_title,
          });
        }
        this.dropLocation.screen = -1;
        // alert(`You dropped with data: ${JSON.stringify(data)}`);
      },
      closeModalSection: function() {},
    },
  };
</script>

<style>
  .left-nav {
    width: 250px;
    min-width: 250px;
  }

  .nav-underline .nav-link {
    padding: 5px;
    color: grey;
    position: relative;
    border-width: 0 !important;
    border-color: transparent !important;
  }

  .nav-underline .nav-link.active {
    color: var(--lightgrey);
    font-weight: 500;
  }

  .nav-underline .nav-link.active:after {
    left: 0;
    bottom: 0;
    content: "";
    width: 100%;
    height: 2px;
    display: block;
    position: absolute;
    background-color: #fff;
  }

  .schedule-info-sticky {
    position: fixed;
    left: 50%;
    min-width: 880px;
    bottom: 15px;
    font-size: 14px;
    z-index: 9991;
    padding: 15px 15px 15px 15px;
    /* padding: 25px 15px 25px 15px; */
    border-radius: 5px;
    background-color: white;
    transform: translateX(-50%);
    box-shadow: 0px 2.5px 5px 5px #80808021;
    /* height: 94px; */
    color: black;
  }

  .custom-caret::after {
    top: 47.5%;
    right: 0px;
    width: 7px;
    content: "";
    height: 7px;
    display: block;
    position: absolute;
    transform: rotate(-45deg);
    border-left: 1.5px solid grey;
    border-bottom: 1.5px solid grey;
  }

  .schedule-price-dropdown {
    left: 0;
    width: 100%;
    position: absolute;
    border-radius: 5px;
    max-height: 70vh;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff;
    bottom: calc(100% + 5px);
    border: 1px solid #d3d3d3;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .hover-card-list:hover,
  .hover-card-list:active,
  .hover-card-list.active,
  .hover-card-list:focus {
    background-color: #fff;
    color: #fff;
  }

  .date-arrow {
    padding-top: 8px;
    z-index: 100;
  }

  .date-arrow-left {
    margin-right: -10px;
  }

  .date-arrow-right {
    margin-left: -10px;
  }

  .h-50 {
    height: 50px !important;
  }

  .w-60 {
    width: 60px !important;
  }

  .plus-minus-btn {
    color: #fff;
    border: none;
    display: block;
    font-size: 35px;
    padding: 0 10px;
    margin: 0 15px;
    border-radius: 8px;
    background-color: var(--primary);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleComponents/ViewScheduleDD-1.vue